import moment from 'moment';
import GoogleMapReact from 'google-map-react';
import { chunk, round } from 'lodash';

import {
  Listing,
  Listings,
  Coordinates,
  Bounds,
  TailoredRegionMarkers,
  ADR,
  OccupancyRate,
  Revenue,
  TempObject,
  DigestCardGraphData,
  BookingsPerMonth,
  PieChartData,
  NearbyRecommendedMarket,
  Rate,
  ListingVal,
  Search,
  BarGraphData,
  ListingLegacy,
  RechartsDataFormat,
  ParsedGuest,
  SubscriptionPlan,
  Amenities,
} from '../interfaces/idashboard';
import { FilterVal, ListingsProp, SearchProp, VisibleListingsProp } from '../interfaces/iproptypes';
import {
  amenitiesObject,
  COLOR_GREEN,
  COLOR_RED_LIGHT,
  COLOR_YELLOW,
  DATA_VERIFICATION_ATTEMPT_TRACKER_LS_KEY,
  exchangeRates,
  mapStyles,
  FREE_MARKET_SEARCH_LIMIT,
  sampleMarket,
  TOP_BANNER_PADDING,
  TOP_BANNER_PADDING_MOBILE,
  countryListWithCode,
  AVAILABLE_COUNTRY,
  DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE,
  shortMonthNames,
  mlaMonthsShort,
  MONTHLY_TOP_HOST_LIMIT,
  BEST_AIRBNB_MARKET_COUNTRY_CODE_MAP,
  ALL_COUNTRY,
  COUNTRY_ALIASES,
  BEST_MARKET_BLOGS_WITH_THE_PREFIX,
  RoutesMap,
  MARKET_HOME_CHAT_PATH,
  DEFAULT_FILTER_VALUES,
  MARKET_SEARCH_HISTORY,
  GRAPH_EXPORT_LIMIT_MULTIPLIER,
} from '../utils/const';
import { stripeConfig, ProductIDOptions } from '../utils/stripeConfig';
import '../App/Dashboards/Dashboard.scss';

import * as d3 from 'd3';
// import * as CryptoJS from "crypto-js";
// import * as fernet from "fernet";
import { Loader } from '@googlemaps/js-api-loader';
import { User } from 'src/interfaces/iuser';
import { callApi } from 'src/core/callApi';
import { CachedMarketDataTypes } from 'src/interfaces/apiTypes';
import { number } from 'prop-types';
import { GOOGLE_MAPS_API_KEY } from 'src/utils/keys';
import { timeZoneCCMap } from 'src/App/assets/timeZoneCCMap';
import { timeZoneCoordinatesMap } from 'src/App/assets/timeZoneCoordsMap';
import bbox from '@turf/bbox';
import * as turf from '@turf/helpers';
import {
  COLOR_ERROR,
  COLOR_WARNING,
  COLOR_SUCCESS,
  COLOR_PRIMARY_2,
  COLOR_PRIMARY_1,
  COLOR_TERTIARY_1,
} from 'src/utils/colors';
const classifyPoint = require('robust-point-in-polygon');

// Import internal helper functions
import {
  // Helper functions
  areCoordinatesSame,
  parseRing,
  toRad,
  toDegrees,
  getSuitableTextForMissingAndInactiveData,
  convertKeys,
  getCreditUsedThisMonth,
  // Internal functions
  processMultiPolygon,
  getBoundedListings,
  checkHostType,
  applyRevenueFilter,
  applyPriceTierFilter,
  jsonArrayToCSV,
  getPropertyTypeFreq,
  getPropertySizeFreq,
  getBookingTypeAndLeadFreq,
  getUserFriendlyPropertyTypeName,
  normalizeLongitude,
  trackUserDataVerificationAttempt,
  initializeAmenityDistributionByPropertySize,
  dateDeforeNDays,
  convertDateToString,
  processListingData,
  processBookingListingData,
  isMiddleEastTimezone,
  normalizeCountryKey,
  buildCountryLookupMaps,
  capitalizeText,
} from './functions.internal';

export function setMarkerParams(markerParam, bounds, marketBoundary = null) {
  markerParam['nwLat'] = bounds['nw']['lat'];
  markerParam['nwLng'] = bounds['nw']['lng'];
  markerParam['seLat'] = bounds['se']['lat'];
  markerParam['seLng'] = bounds['se']['lng'];
  if (marketBoundary) {
    markerParam['marketPolygon'] = marketBoundary;
  }
}


export const isDateBeforeFourWeeks = dateString => {
  if (dateString) {
    const inputDate = new Date(dateString);
    const currentDate = new Date();
    if (inputDate > currentDate) {
      return true;
    }

    const oneWeeksAgo = new Date();
    oneWeeksAgo.setDate(currentDate.getDate() - 4 * 7); // 4 weeks = 4 * 7 days

    return inputDate < oneWeeksAgo;
  }
  return false;
};


export const processPolygon = (polygonRaw: string, multiPolygonRaw: string) => {
  if (!polygonRaw) {
    return processMultiPolygon(multiPolygonRaw);
  }

  // Remove "POLYGON" and outer parentheses
  polygonRaw = polygonRaw.replace('POLYGON', '').trim();
  polygonRaw = polygonRaw.replace(/^\(/, '').replace(/\)$/, '');

  const ringStrings = polygonRaw.split('),');
  const rings: Coordinates[][] = ringStrings.map(r => parseRing(r)).filter(r => r.length > 0);
  return rings;
};

export const processTailoredRegionMarkers = listings => {
  let retVals: TailoredRegionMarkers[] = [];
  if (!listings) {
    return retVals;
  }
  for (const listing of listings) {
    let retListing = {} as TailoredRegionMarkers;
    retListing.listingID = listing[0];
    retListing.latitude = listing[1];
    retListing.longitude = listing[2];
    retListing.room_type = listing[3];
    retVals.push(retListing);
  }

  return retVals;
};


export const updateListings = (currentListings: Listings, visibleListings: Set<String>) => {
  for (const listingID in currentListings) {
    if (currentListings.hasOwnProperty(listingID)) {
      currentListings[listingID].visible = visibleListings.has(listingID);
    }
  }

  return currentListings;
};




export const getFilteredListings = (
  listings: Listings,
  filters: FilterVal,
  filterActive: boolean,
  revenueRange?: { [key: number]: 'visible' | 'hidden' },
  onlyConsiderRevenueFilter: boolean = false,
  filtersToConsider: string[] = []
) => {
  let filteredListings: string[] = [];

  const isFilterToConsider = (filter: string) => {
    if (filtersToConsider.length === 0) return true;

    if (filtersToConsider.includes(filter)) {
      return true;
    }
    return false;
  };

  if (!filterActive) {
    return Object.keys(listings);
  }

  let filteredListingsList: string[][] = [];

  let bathroom_values: number[] = [];
  let host_type_value: 'independent' | 'professional' | 'both' = 'both';
  let number_of_reviews: number | 'all' = 'all';
  let rating: [number, number] = [-1, -1];
  let sleeps: [number, number] = [-1, -1];
  let minimum_nights: [number, number] = [1, 30];

  const amenities: { [index: string]: boolean } = {};

  const showNoListings: boolean =
    !filters.roomType.includes('entire_home') &&
    !filters.roomType.includes('condo') &&
    !filters.roomType.includes('all') &&
    (!filters.bedrooms.includes(100) ||
      filters.bedrooms.length > 1 ||
      !filters.bathrooms.includes(100) ||
      filters.bathrooms.length > 1);

  if (showNoListings) {
    return [];
  }

  !onlyConsiderRevenueFilter &&
    Object.keys(filters).forEach(filter => {
      const value: string | string[] | Number | Number[] | { [index: string]: boolean } =
        filters[filter];
      let tempFilteredListings: string[] = [];

      if (filter === 'roomType') {
        if (
          (value as string[]).includes('all') ||
          (value as string[]).length === 0 ||
          !isFilterToConsider('roomType')
        ) {
          tempFilteredListings = Object.keys(listings);
        } else {
          if ((value as string[]).includes('entire_home')) {
            Object.keys(listings).forEach(listingID => {
              const listing = listings[listingID];
              if (
                listing.room_type &&
                listing.room_type === 'entire_home' &&
                listing.property_type &&
                listing.property_type !== 'condo'
              ) {
                tempFilteredListings.push(listingID);
              }
            });
          }

          if ((value as string[]).includes('condo')) {
            Object.keys(listings).forEach(listingID => {
              const listing = listings[listingID];
              if (listing.property_type && listing.property_type === 'condo') {
                tempFilteredListings.push(listingID);
              }
            });
          }

          Object.keys(listings).forEach(listingID => {
            const listing = listings[listingID];
            if ((value as string[]).includes(listing.room_type)) {
              tempFilteredListings.push(listingID);
            }
          });
        }
      }

      if (filter === 'bedrooms') {
        const bedroom_values: (number | string)[] = value as (number | string)[];

        if (
          bedroom_values.length === 0 ||
          bedroom_values.includes(100) ||
          !isFilterToConsider('bedrooms')
        ) {
          tempFilteredListings = Object.keys(listings);
        } else {
          Object.keys(listings).forEach(listingID => {
            const listing = listings[listingID];
            const roomType = listing.room_type;
            const bedrooms: number = listing.bedrooms === 'Studio' ? 0 : Number(listing.bedrooms);
            if (
              (listing.room_type && listing.room_type === 'entire_home') ||
              (listing.property_type && listing.property_type === 'condo')
            ) {
              if (bedroom_values.includes(bedrooms)) {
                tempFilteredListings.push(listingID);
              }
              //handling 6+ bedrooms
              if (bedroom_values.includes(6) && bedrooms > 6) {
                tempFilteredListings.push(listingID);
              }
            }

            ['private_room', 'hotel_room', 'shared_room'].forEach(type => {
              if (roomType === type && bedroom_values.includes(type)) {
                tempFilteredListings.push(listingID);
              }
            });
          });
        }
      }

      if (filter === 'bathrooms') {
        bathroom_values = value as number[];
      }

      if (filter === 'hostType') {
        host_type_value = value as 'independent' | 'professional' | 'both';
      }

      if (filter === 'accommodates') {
        const lowerVal = value[0] as number;
        const upperVal = value[1] as number;
        sleeps = [lowerVal, upperVal];
      }

      if (filter === 'minimum_nights') {
        const lowerVal = value[0] as number;
        const upperVal = value[1] as number;

        minimum_nights = [lowerVal, upperVal];
      }

      if (filter === 'number_of_reviews') {
        number_of_reviews = value as number | 'all';
      }

      if (filter === 'rating') {
        rating = value as [number, number];
      }

      if (filter === 'amenities') {
        for (const key in value as { [index: string]: boolean }) {
          if (value[key] != null) {
            amenities[key] = value[key];
          }
        }
      }

      filteredListingsList.push(tempFilteredListings);
    });

  const numberOfReviewsLowerBound = number_of_reviews !== 'all' ? number_of_reviews : 0;

  // Applying AND to the filtered results from roomType, and bedrooms and applying rest of the filters
  !onlyConsiderRevenueFilter &&
    filteredListingsList.reduce((filteredListings1, filteredListings2) => {
      filteredListings1.forEach(filteredListing => {
        if (filteredListings2.includes(filteredListing)) {
          // applying number of reviews filter
          if (numberOfReviewsLowerBound && isFilterToConsider('number_of_reviews')) {
            listings[filteredListing].visible_review_count > numberOfReviewsLowerBound &&
              filteredListings.push(filteredListing);
          } else {
            filteredListings.push(filteredListing);
          }
        }
      });

      // applying bathrooms filter
      filteredListings =
        bathroom_values.length === 0 ||
        bathroom_values.includes(100) ||
        !isFilterToConsider('bathrooms')
          ? filteredListings
          : filteredListings.filter(filteredListing => {
              const bathroom = listings[filteredListing].bathrooms;
              if (bathroom_values.includes(bathroom)) {
                return true;
              }
              if (bathroom_values.includes(6) && bathroom > 6) {
                return true;
              }
              return false;
            });

      // applying host type filter
      filteredListings =
        host_type_value === 'both' || !isFilterToConsider('hostType')
          ? filteredListings
          : filteredListings.filter(filteredListing => {
              const hostListingCount = listings[filteredListing].hostListingCount;
              const isHostTypeMatching = checkHostType(
                host_type_value as 'independent' | 'professional',
                hostListingCount
              );
              if (isHostTypeMatching) {
                return true;
              }
              return false;
            });

      // applying sleeps filter
      const sleepsLowerBound = sleeps[0];
      const sleepsUpperBound = sleeps[1];

      filteredListings =
        (sleepsLowerBound === -1 && sleepsUpperBound === -1) || !isFilterToConsider('accommodates')
          ? filteredListings
          : filteredListings.filter(filteredListing => {
              const accommodates = listings[filteredListing].accommodates;
              if (accommodates >= sleepsLowerBound && accommodates <= sleepsUpperBound) {
                return true;
              }
              if (sleepsUpperBound === 16 && accommodates > 16) {
                return true;
              }
              return false;
            });

      // applying minimum nights filter
      const minimumNightsLowerBound = minimum_nights[0];
      const minimumNightsUpperBound = minimum_nights[1];
      filteredListings =
        (minimumNightsLowerBound === 1 && minimumNightsUpperBound === 30) ||
        !isFilterToConsider('minimum_nights')
          ? filteredListings
          : filteredListings.filter(listing => {
              const minimumNightsForThisListings = listings[listing].minimum_nights;

              return (
                minimumNightsLowerBound <= minimumNightsForThisListings &&
                minimumNightsUpperBound > minimumNightsForThisListings
              );
            });

      // applying the rating filter
      let lowestRating = rating[0];
      const heighestRating = rating[1];
      if (lowestRating === 3.9) {
        lowestRating = 0;
      }
      filteredListings =
        (lowestRating === 0 && heighestRating === 5) || !isFilterToConsider('rating')
          ? filteredListings
          : filteredListings.filter(listing => {
              let ratingOfCurrentListing = listings[listing].review_scores_rating;
              ratingOfCurrentListing = ratingOfCurrentListing ? ratingOfCurrentListing : 0;
              return (
                lowestRating <= ratingOfCurrentListing && heighestRating >= ratingOfCurrentListing
              );
            });

      // applying amenities filter
      if (filters['amenities']) {
        filteredListings = !isFilterToConsider('amenities')
          ? filteredListings
          : filteredListings.filter(filteredListing => {
              return Object.entries(amenities).every(([amenity, amenityState]) => {
                // If amenityState is true, include listings that have this amenity
                // If amenityState is false, exclude listings that have this amenity
                return amenityState
                  ? listings[filteredListing].amenities[amenity]
                  : !listings[filteredListing].amenities[amenity];
              });
            });
      }

      return filteredListings;
    });

  // revenue potential filter
  if (revenueRange) {
    if (onlyConsiderRevenueFilter) {
      filteredListings = Object.keys(listings);
    }

    const revenueFilterValue: (number | 'all')[] = filters.revenueFilter;

    filteredListings =
      revenueFilterValue.includes('all') || revenueFilterValue.length === 4
        ? filteredListings
        : applyRevenueFilter(
            revenueRange,
            filteredListings,
            listings,
            revenueFilterValue as number[]
          );
  }

  const priceTierFilterValue: (number[] | string[] | 'all')[] = filters.priceTierFilter;
  filteredListings =
    priceTierFilterValue.includes('all') || priceTierFilterValue.length === 5
      ? filteredListings
      : applyPriceTierFilter(filteredListings, listings, priceTierFilterValue as number[][]);

  return filteredListings;
};


export const titleCase = (str: string | undefined) => {
  if (!str) {
    return '';
  }
  try {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  } catch (e) {
    console.log('Error in titleCase function', e);
    return str;
  }
};

export const processAirbnbAuthResponse = response => {
  let error = '';
  if (
    response.action === 'wrong_credentials' ||
    response.action === 'wrong_code' ||
    response.action === 'support' ||
    response.action === 'failed'
  ) {
    error = response.action;
  }
  return {
    action: response.action,
    captcha_url: response.hasOwnProperty('airlock_url') ? response.airlock_url : '',
    airlock_id: response.hasOwnProperty('airlock_id') ? response.airlock_id : '',
    user_id: response.hasOwnProperty('userID') ? response.userID : '',
    error: error,
  };
};

export const getMonthlyKeyMetrics = (
  keyMetricsName: string,
  listings: any[],
  singleListing = false,
  noAvg = false,
  percentile = 0.5,
  useHistory = false
) => {
  let monthlyKeyMetrics: ADR[] | OccupancyRate[] | Revenue[] | BookingsPerMonth[] = [];
  let values = [] as number[][];

  if (listings.length === 0) return monthlyKeyMetrics;

  if (singleListing) {
    const listing = listings[0];
    if (!listing[`${keyMetricsName}`] || !Array.isArray(listing[`${keyMetricsName}`])) {
      return monthlyKeyMetrics;
    }
    monthlyKeyMetrics =
      // useHistory && listing.hasOwnProperty(`${keyMetricsName}Historical`)
      //   ? listing[`${keyMetricsName}Historical`].concat(listing[`${keyMetricsName}`])
      //   :
      listing[`${keyMetricsName}`];
    return monthlyKeyMetrics;
  }

  // creating object for each month

  const sampleListing = listings.length > 3 ? listings[3] : listings[0];
  const sampleMonthlyRawData =
    // useHistory && sampleListing.hasOwnProperty(`${keyMetricsName}Historical`)
    //   ? sampleListing[`${keyMetricsName}Historical`].concat(sampleListing[`${keyMetricsName}`])
    //   :
    sampleListing[`${keyMetricsName}`];

  sampleMonthlyRawData.map(
    (obj: ADR | OccupancyRate | Revenue | BookingsPerMonth, index: number) => {
      monthlyKeyMetrics[index] = {} as ADR | OccupancyRate | Revenue | BookingsPerMonth;
      monthlyKeyMetrics[index].date = obj.date;
      monthlyKeyMetrics[index][`${keyMetricsName}`] = 'missing';
      values[index] = [];
    }
  );

  // pushing values to values list by iterating through listings
  listings.map((listing: ListingLegacy) => {
    const monthlyRawData =
      // useHistory && sampleListing.hasOwnProperty(`${keyMetricsName}Historical`)
      //   ? listing[`${keyMetricsName}Historical`].concat(listing[`${keyMetricsName}`])
      //   :
      listing[`${keyMetricsName}`];

    monthlyRawData.map((obj: ADR | OccupancyRate | Revenue | BookingsPerMonth, index: number) => {
      if (obj[`${keyMetricsName}`] !== 'missing' && obj[`${keyMetricsName}`] !== 'inactive') {
        values[index].push(obj[`${keyMetricsName}`]);
      }
    });
  });

  // calculating percentile for each month

  monthlyKeyMetrics.map((keyMetricObj, index) => {
    if (values[index].length > 0) {
      if (!noAvg) {
        values[index].sort((a, b) => a - b);
        keyMetricObj[`${keyMetricsName}`] = Math.round(d3.quantile(values[index], percentile));
        keyMetricObj[`${keyMetricsName}0.25`] = Math.round(d3.quantile(values[index], 0.25));
        keyMetricObj[`${keyMetricsName}0.5`] = Math.round(d3.quantile(values[index], 0.5));
        keyMetricObj[`${keyMetricsName}0.75`] = Math.round(d3.quantile(values[index], 0.75));
        keyMetricObj[`${keyMetricsName}0.9`] = Math.round(d3.quantile(values[index], 0.9));
      } else {
        keyMetricObj[`${keyMetricsName}`] = values[index].reduce((acc, val) => acc + val, 0);
      }
    }
  });
  return monthlyKeyMetrics;
};

export const processLastMonthData = (
  listings: Listing[] | ListingLegacy[],
  metricsKey: 'occupancy_rate' | 'revenue',
  percentile = 0.5
) => {
  let lastMonthData: 'missing' | string = 'missing';
  let values = [] as number[];

  listings.forEach((listing: Listing | ListingLegacy) => {
    if (
      listing[`${metricsKey}PrevMonth`] &&
      listing[`${metricsKey}PrevMonth`] !== 'missing' &&
      listing[`${metricsKey}PrevMonth`] !== 'inactive'
    ) {
      values.push(listing[`${metricsKey}PrevMonth`] as number);
    }
  });

  if (values.length > 0) {
    values.sort((a, b) => a - b);
    lastMonthData = Math.round(d3.quantile(values, percentile)).toString();
  }

  return lastMonthData;
};

export const getDynamicExtraFees = (
  currency: string,
  cachedData: { [key: string]: number } | null = null
) => {
  let dynamicExtraFees: BarGraphData[] = [];

  if (cachedData) {
    const cleaningFee = cachedData['cleaning_fee'] ?? 0;
    const extraGuestFee = cachedData['extra_guest_fee'] ?? 0;
    dynamicExtraFees.push({
      keyLong: 'Cleaning Fee',
      value: convertCurrency(currency, cleaningFee),
    });
    dynamicExtraFees.push({
      keyLong: 'Extra Guest Fee',
      value: convertCurrency(currency, extraGuestFee),
    });
  }

  return dynamicExtraFees;
};

export const returnLoadingText = (emptySearchBar: boolean) => {
  if (emptySearchBar) {
    return '';
  } else {
    return 'loading...';
  }
};

export const convertToUSD = (currency: string, amountInCurrency: number, round = false) => {
  if (exchangeRates[currency]) {
    const usdAmount = amountInCurrency / exchangeRates[currency].rate;
    return round ? Math.round(usdAmount * 100) / 100 : usdAmount;
  } else {
    throw new Error(`Exchange rate for ${currency} not found.`);
  }
};

export const convertCurrency = (
  currency: string,
  dollarAmt: number,
  round = false,
  rawValue = false
) => {
  if (rawValue) {
    return dollarAmt * exchangeRates[currency].rate;
  }
  if (round) {
    return Math.round(dollarAmt * exchangeRates[currency].rate * 100) / 100;
  } else {
    return Math.round(dollarAmt * exchangeRates[currency].rate);
  }
};

export const roundNumber = (amount: number) => {
  return Math.round(amount);
};

/**
 * Format a value that is **already in the user's display currency** (i.e. already
 * went through convertApiCurrency). Applies symbol + thousand-separator only — no
 * exchange-rate multiplication.
 */
export const formatDisplayCurrency = (
  currency: string,
  value: number,
  abbreviate = false
): string => {
  const sym = exchangeRates[currency]?.symbol || '$';
  if (abbreviate) return `${sym}${abbreviateNumber(value, true)}`;
  return `${sym}${formatCurrency(String(Math.round(value)))}`;
};

export const formatCurrency = (curString: string) => {
  const p = curString.indexOf('.');
  return curString.replace(/\d(?=(?:\d{3})+(?:\.|$))/g, (m, i) => (p < 0 || i < p ? `${m},` : m));
};

export const formatCurrencyBasedOnCountryCode = (value: number, currency: string) => {
  if (value == null || value === undefined) return '';
  if (currency == 'INR') {
    return value.toLocaleString('en-IN');
  }
  return value.toLocaleString('en-US');
};

export const isEqualObject = (obj1: any, obj2: any) => {
  const obj1Length = Object.keys(obj1).length;
  const obj2Length = Object.keys(obj2).length;

  if (obj1Length === obj2Length) {
    return Object.keys(obj1).every(key => obj2.hasOwnProperty(key) && obj2[key] === obj1[key]);
  }
  return false;
};

export const isEmpty = obj => {
  if (Object.keys(obj).length === 0) {
    return true;
  } else if (obj.ltm_performance) {
    const ltm = obj.ltm_performance;
    if (
      ltm.revenue === null &&
      ltm.cleaning_fee === 0 &&
      ltm.booking === 0 &&
      ltm.occupancy_rate === null &&
      ltm.adr === null &&
      ltm.supply === 0
    ) {
      return true;
    }
  }

  return false;
};

export const isNoDataInMarket = obj => {
  if (obj == null || typeof obj !== 'object') {
    return true;
  }
  if (Object.keys(obj).length === 0) {
    return true;
  } else if (obj.ltm_performance) {
    const ltm = obj.ltm_performance;
    if (
      ltm.revenue === null &&
      ltm.cleaning_fee === 0 &&
      ltm.booking === 0 &&
      ltm.occupancy_rate === null &&
      ltm.adr === null &&
      ltm.supply === 0
    ) {
      return true;
    }
  }
  return false;
};




export const getSupplyByPropertyType = (cachedData: { [key: string]: number }) => {
  let supplyByPropertyType: PieChartData[] = [];
  let totalSupply = 0;

  if (cachedData) {
    totalSupply = Object.values(cachedData).reduce((acc, cur) => acc + cur, 0);
    supplyByPropertyType = Object.keys(cachedData).map((propertyType: string) => {
      return {
        name: getUserFriendlyPropertyTypeName(propertyType),
        value: cachedData[propertyType],
        percentage: Math.round((cachedData[propertyType] / totalSupply) * 100),
        legend: getUserFriendlyPropertyTypeName(propertyType)[0],
      };
    });
  }

  return supplyByPropertyType;
};


export const getSupplyByPropertySize = (cachedData: { [key: string]: number } | null = null) => {
  let propertySizeFreq: { [key: string]: number } = {};
  if (cachedData) {
    propertySizeFreq = cachedData;
  }
  let supplyByPropertySize: BarGraphData[] = [];
  supplyByPropertySize = Object.keys(propertySizeFreq).map((bed: string) => {
    return {
      keyShort: getUserFriendlyPropertySizeName(bed, true),
      keyLong: getUserFriendlyPropertySizeName(bed),
      value: propertySizeFreq[bed],
    };
  });
  return supplyByPropertySize;
};

export const getUserFriendlyPropertySizeName = (bed: string, isShort = false) => {
  if (bed === '0') {
    return 'Studio';
  } else if (bed === '1') {
    return isShort ? '1' : '1 bedroom';
  } else if (bed === '6') {
    return isShort ? '6+' : '6+ bedrooms';
  } else if (bed === 'rooms') {
    return isShort ? 'rooms' : 'private/hotel/shared rooms';
  } else {
    return isShort ? bed : bed + ' bedrooms';
  }
};


export const getAmenityDistribution = (cachedData: { [key: string]: number } | null = null) => {
  let amenityFreq: { [key: string]: number } = {};
  Object.values(amenitiesObject).forEach(key => {
    amenityFreq[key] = 0;
  });
  let amenityDistribution: BarGraphData[] = [];

  if (cachedData) {
    amenityDistribution = Object.keys(cachedData)
      .map(amenity => ({
        keyLong: amenitiesObject[amenity],
        value: cachedData[amenity],
      }))
      .sort((a, b) => b.value - a.value);
  }

  return amenityDistribution;
};

export const getCancellationPolicyDistribution = (
  cachedData: { [key: string]: number } | null = null
) => {
  let cancellationPolicyFreq = {
    'Flexible Cancellation Policy': 0,
    'Moderate Cancellation Policy': 0,
    'Strict Cancellation Policy': 0,
  };
  let cancellationPolicyDistribution: PieChartData[] = [];

  if (cachedData) {
    cancellationPolicyDistribution = Object.keys(cancellationPolicyFreq)
      .map(cancellationPolicy => ({
        name: cancellationPolicy,
        value: cachedData[cancellationPolicy.toLowerCase()[0]],
        percentage: cachedData[cancellationPolicy.toLowerCase()[0]],
        legend: cancellationPolicy[0],
      }))
      .sort((a, b) => b.value - a.value);
  }

  return cancellationPolicyDistribution;
};


export const getLTMData = (
  metrics: string,
  data: ADR[] | OccupancyRate[] | Revenue[] | BookingsPerMonth[],
  isAnnual = false
) => {
  let totalVal: number = 0;
  let count: number = 0;
  data.forEach((dataObj: ADR | OccupancyRate | Revenue | BookingsPerMonth) => {
    if (dataObj[`${metrics}`] !== 'missing' && dataObj[`${metrics}`] !== 'inactive') {
      totalVal += dataObj[`${metrics}`];
      count++;
    }
  });

  if (count === 0) {
    return -1;
  }

  if (isAnnual) {
    return totalVal;
  }

  const ltmData = Math.round(totalVal / count);
  return ltmData;
};

export const makeDownloadableBlob = (data, name: string, addHeader = true, isDataCsv = false) => {
  const csvData: string = isDataCsv ? data : jsonArrayToCSV(data, addHeader);
  const blob: Blob = new Blob([csvData], {
    type: 'text/csv',
  });
  const url: string = window.URL.createObjectURL(blob);
  const link: HTMLAnchorElement = document.createElement('a');
  link.href = url;
  link.setAttribute('download', name + '.csv');
  document.body.appendChild(link);
  link.click();
  if (link && link.nodeType && link.nodeType === Node.ELEMENT_NODE) {
    document.body.removeChild(link);
  }
};

export const getSeasonalityBarColor = (
  seaosnality: number | null,
  returnLabel: boolean = false
) => {
  if (!seaosnality) return '';
  if (seaosnality <= 50) return returnLabel ? 'High' : COLOR_GREEN;
  else if (seaosnality <= 75) return returnLabel ? 'Mid' : COLOR_YELLOW;
  else return returnLabel ? 'Low' : COLOR_RED_LIGHT;
};

export const getSeasonality = (graphData, renderIn = '', selectedPercentile = '50') => {
  let seasonalityData = {} as {
    highestRevenue: Revenue;
    lowestRevenue: Revenue;
    seasonality: number;
  };

  let revenues: Revenue[] = [];

  if (renderIn === 'overview') {
    revenues = graphData.map(data => {
      return {
        date: data.monthYear,
        revenue: data.LTMData[`revenue${selectedPercentile}`] as number | 'missing' | 'inactive',
      };
    });
  } else if (renderIn === 'estimator') {
    revenues = graphData.map(data => {
      return {
        date: data.timePeriod,
        revenue: data[selectedPercentile] as number | 'missing' | 'inactive',
      };
    });
  } else {
    revenues = graphData.map(data => {
      return { date: data.timePeriod, revenue: data.Revenue as number | 'missing' | 'inactive' };
    });
  }

  const filteredRevenues = revenues.filter(
    revenue =>
      revenue.revenue !== 'missing' &&
      revenue.revenue !== 'inactive' &&
      !Number.isNaN(revenue.revenue)
  );

  const sortedRevenues = [...filteredRevenues].sort((a, b) => {
    return (a.revenue as number) - (b.revenue as number);
  });

  seasonalityData.highestRevenue = sortedRevenues[sortedRevenues.length - 1];
  seasonalityData.lowestRevenue = sortedRevenues[0];

  if (sortedRevenues.length > 0) {
    if (sortedRevenues.length >= 6) {
      const highRevenues: number[] = [
        sortedRevenues[sortedRevenues.length - 1]?.revenue as number,
        sortedRevenues[sortedRevenues.length - 2]?.revenue as number,
        sortedRevenues[sortedRevenues.length - 3]?.revenue as number,
      ];

      const lowRevenues: number[] = [
        sortedRevenues[0]?.revenue as number,
        sortedRevenues[1]?.revenue as number,
        sortedRevenues[2]?.revenue as number,
      ];

      const avgHigh =
        highRevenues.reduce((partial_sum: number, revenue: number) => partial_sum + revenue, 0) /
        highRevenues.length;

      const avgLow =
        lowRevenues.reduce((partial_sum: number, revenue: number) => partial_sum + revenue, 0) /
        lowRevenues.length;

      seasonalityData.seasonality = Math.round(((avgHigh - avgLow) / avgHigh) * 100);
    } else {
      const highestRevenue = sortedRevenues[sortedRevenues.length - 1]?.revenue as number;
      const lowestRevenue = sortedRevenues[0]?.revenue as number;
      seasonalityData.seasonality = Math.round(
        ((highestRevenue - lowestRevenue) / highestRevenue) * 100
      );
    }
  } else {
    // when no value is present
    seasonalityData.seasonality = 0;
  }

  return seasonalityData;
};

export const parseGraphVal = (
  data: ADR[] | OccupancyRate[] | Revenue[],
  yAxis: string,
  currency: string
) => {
  let returnVal: DigestCardGraphData[] = [];

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  data.forEach((dataObj: ADR | OccupancyRate | Revenue) => {
    const key = Object.keys(dataObj)[1];
    const date = dataObj['date'];
    const monthName = monthNames[parseInt(date.split('-')[1]) - 1];
    const year = date.split('-')[0];
    returnVal.push({
      timePeriod: monthName + ', ' + year,
      [yAxis]:
        dataObj[`${key}`] != 'missing' && dataObj[`${key}`] != 'inactive' && key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}`])
          : dataObj[`${key}`],
      '0.25':
        key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}0.25`])
          : dataObj[`${key}0.25`],
      '0.5':
        key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}0.5`])
          : dataObj[`${key}0.5`],
      '0.75':
        key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}0.75`])
          : dataObj[`${key}0.75`],
      '0.9':
        key !== 'occupancy'
          ? convertCurrency(currency, dataObj[`${key}0.9`])
          : dataObj[`${key}0.9`],
    });
  });

  return returnVal;
};

const getKeyForMarketHistoricalLevelData = yAxisName => {
  if (yAxisName === 'Revenue') {
    return 'revenue';
  } else if (yAxisName === 'Occupancy Rate') {
    return 'occupancy';
  } else {
    return 'adr';
  }
};

export const getHeadingStyle = (color: string) => {
  return {
    color: color,
    fontWeight: 'bold',
    marginBottom: '5px',
  };
};

export const getPropertySizePreviewTextObj = (
  parentCard: 'demand' | 'supply',
  filters: FilterVal,
  listings: Listing[]
) => {
  const variantKey =
    filters.bedrooms.length > 0 && filters.bedrooms[0] !== 100
      ? filters.bedrooms[0].toString()
      : '1';

  const propertySizeData =
    parentCard === 'supply' ? getPropertySizeFreq(listings) : getPropertySizeFreq(listings, true);
  const totalVal = Object.values(propertySizeData).reduce((a, b) => a + b);
  return {
    userFriendlyDataName: getUserFriendlyPropertySizeName(variantKey),
    previewVal: `${Math.round((propertySizeData[variantKey] / totalVal) * 100)}%`,
  };
};

export const getPropertyTypePreviewTextObj = (
  parentCard: 'demand' | 'supply',
  filters: FilterVal,
  listings: Listing[]
) => {
  const variantKey =
    filters.roomType.length > 0 && filters.roomType[0] !== 'all'
      ? filters.roomType[0]
      : 'entire_home';

  const propertyTypeData =
    parentCard === 'supply' ? getPropertyTypeFreq(listings) : getPropertyTypeFreq(listings, true);
  const totalVal = Object.values(propertyTypeData).reduce((a, b) => a + b);
  return {
    userFriendlyDataName: getUserFriendlyPropertyTypeName(variantKey),
    previewVal: `${Math.round((propertyTypeData[variantKey] / totalVal) * 100)}%`,
  };
};

export const getBookingTypeAndLeadPreviewTextObj = (
  variant: 'bookingType' | 'bookingLead',
  listings: Listing[]
) => {
  const [bookingTypesFreq, bookingLeadsFreq] = getBookingTypeAndLeadFreq(listings);
  const dataToUse = variant === 'bookingType' ? bookingTypesFreq : bookingLeadsFreq;
  const variantKey = Object.keys(dataToUse).reduce((a, b) => (dataToUse[a] > dataToUse[b] ? a : b));
  const totalVal = Object.values(dataToUse).reduce((a, b) => a + b);
  return {
    userFriendlyDataName: variantKey,
    previewVal: `${Math.round((dataToUse[variantKey] / totalVal) * 100)}%`,
  };
};

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const intersect = (a: any[], b: any[]) => {
  const setB = new Set(b);
  const result: any[] = [];
  for (const item of a) {
    if (setB.has(item)) {
      result.push(item);
    }
  }
  return result;
};

export const getVisibleListings = (
  listings: ListingsProp,
  bounds: Bounds,
  filterActive: boolean,
  filteredListings: string[],
  onlyIDs = false
) => {
  let visibleListings: Listing[] = [];

  if (listings.loading || !listings.data) {
    return visibleListings;
  }

  const boundedListings = getBoundedListings(listings.data, bounds);
  if (boundedListings.length === 0) {
    return visibleListings;
  }

  const visibleListingIDs = filterActive
    ? new Set(intersect(boundedListings, filteredListings))
    : new Set(boundedListings);

  visibleListings = Object.keys(listings.data)
    .filter(listingID => visibleListingIDs.has(`${listingID}`))
    .map(listingID => ({
      listingID,
      ...listings.data[listingID],
    }));

  return onlyIDs ? (Array.from(visibleListingIDs) as string[]) : visibleListings;
};

export const getBoundedClusters = (clusters, bounds) => {
  if (!bounds || !Object.keys(clusters).length) return [];

  try {
    const swBound: Coordinates = bounds.southWest;
    const neBound: Coordinates = bounds.northEast;

    const polygon = [
      [swBound.lat, swBound.lng],
      [swBound.lat, neBound.lng],
      [neBound.lat, neBound.lng],
      [neBound.lat, swBound.lng],
    ];

    let boundedClusters: any[] = [];
    const batchSize = 50;

    const processBatch = batch => {
      batch.forEach(cluster => {
        const point = [cluster.centroid.latitude, cluster.centroid.longitude];
        if (classifyPoint(polygon, point) === -1 || classifyPoint(polygon, point) === 0) {
          boundedClusters.push(cluster);
        }
      });
    };

    const batches = chunk(clusters, batchSize);
    batches.forEach(processBatch);

    return boundedClusters;
  } catch (error) {
    console.log('error in getBoundedClusters', error);
    return [];
  }
};

export const formatGoogleMapsBounds = (mapBounds: GoogleMapReact.Bounds) => {
  const boundsObj: Bounds = {
    northEast: mapBounds.ne,
    southWest: mapBounds.sw,
  };
  return boundsObj;
};

export const convertBoundsArrayToObj = (boundsArray: number[]) => {
  return {
    northEast: {
      lat: boundsArray[3],
      lng: boundsArray[2],
    },
    southWest: {
      lat: boundsArray[1],
      lng: boundsArray[0],
    },
  } as Bounds;
};

export const applySmartBoundsForCoords = (
  map: any,
  maps: any,
  coordinates: Coordinates[][] = [],
  padding: number | undefined = undefined
) => {
  // Create a new LatLngBounds object
  const bounds = new maps.LatLngBounds();

  // Convert each coordinate pair to a LatLng object and extend the bounds
  coordinates.forEach(polygon => {
    polygon.forEach(coord => {
      const latLng = new maps.LatLng(coord.lat, coord.lng);
      bounds.extend(latLng);
    });
  });

  // Fit the map to the computed bounds
  if (padding !== undefined) {
    map.fitBounds(bounds, padding);
  } else {
    map.fitBounds(bounds);
  }
};

export const handleMarketRecommendationClick = (
  nearbyRecommendedMarket: NearbyRecommendedMarket
) => {
  // open link to market in new tab
  const district = nearbyRecommendedMarket.district;
  const city = nearbyRecommendedMarket.city ? nearbyRecommendedMarket.city : '0';
  const countryName = nearbyRecommendedMarket.country
    ? nearbyRecommendedMarket.country.replaceAll(' ', '-')
    : '0';
  const marketLink = `${window.location.origin}/airbnb-data/${countryName}/${city}/${district}`;
  window.open(marketLink, '_blank');
};

export const makeLowerCase = (str: any) => {
  if (typeof str === 'object') {
    return '';
  }

  return str.toString().toLowerCase();
};

export const isObject = (obj: any) => {
  return obj !== null && typeof obj === 'object';
};

export const getGoogleLoader = () => {
  const loader = new Loader({
    apiKey: GOOGLE_MAPS_API_KEY,
    id: '__googleMapsScriptId',
    version: 'weekly',
    libraries: ['drawing', 'places', 'visualization'],
  });
  return loader;
};

export const geocodeAddress = async (address: string, noLoader: boolean = false) => {
  let lat = 0;
  let lng = 0;

  let google;

  if (noLoader) {
    // If noLoader is true, wait for Google Maps to be available
    if (!window.google || !window.google.maps) {
      await new Promise(r => setTimeout(r, 500));
    }
    google = (window as any).google;
  } else {
    // If noLoader is false, use the loader to ensure Google Maps is loaded
    if (window.google && window.google.maps) {
      google = (window as any).google;
    } else {
      google = await getGoogleLoader().load();
    }
  }

  // Verify that google and google.maps are available
  if (!google || !google.maps) {
    console.error('Google Maps API not available');
    return [lat, lng];
  }

  const geocoder = new google.maps.Geocoder();

  await geocoder.geocode({ address: `${address}` }, (results, status) => {
    if (status === 'OK' && results) {
      lat = results[0].geometry.location.lat();
      lng = results[0].geometry.location.lng();
    }
  });

  return [lat, lng];
};

export const calculateSmartDistance = (
  coordinate1: { lat: number; lng: number },
  coordinate2: { lat: number; lng: number }
) => {
  const R = 6371 * 1000; // metres
  const latRad = (coordinate1.lat * Math.PI) / 180;
  const lngRad = (coordinate2.lat * Math.PI) / 180;
  const latDefRad = ((coordinate2.lat - coordinate1.lat) * Math.PI) / 180;
  const lngDefRad = ((coordinate2.lng - coordinate1.lng) * Math.PI) / 180;

  const a =
    Math.sin(latDefRad / 2) * Math.sin(latDefRad / 2) +
    Math.cos(latRad) * Math.cos(lngRad) * Math.sin(lngDefRad / 2) * Math.sin(lngDefRad / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  let d = R * c; // in metres
  let unit = 'm';
  if (d >= 1000) {
    d = d / 1000;
    d = Math.round(d * 100) / 100;
    unit = 'km';
  } else {
    d = Math.round(d);
  }
  return `${d} ${unit}`;
};

export const getFuture30DaysKeyMetrics = (rates: { [date: string]: Rate }) => {
  const next30DaysRates = Object.values(rates).slice(0, 30);
  const avgDailyRateNext30Days = Math.round(
    next30DaysRates.reduce((cur, rate) => cur + rate.rate, 0) / 30
  );
  const next30DaysBookedDaysCount = next30DaysRates.reduce(
    (cur, rate) => (rate.status === 'booked' || rate.status === 'recentlyBooked' ? cur + 1 : cur),
    0
  );
  const next30DaysAvailableDaysCount = next30DaysRates.reduce(
    (cur, rate) => (rate.status === 'available' ? cur + 1 : cur),
    0
  );
  const occupancyRateNext30Days = Math.round((next30DaysBookedDaysCount / 30) * 100);

  const avgAvailableDailyRateNext30Days =
    next30DaysAvailableDaysCount !== 0
      ? Math.round(
          next30DaysRates.reduce(
            (cur, rate) => (rate.status === 'available' ? cur + rate.rate : cur),
            0
          ) / next30DaysAvailableDaysCount
        )
      : 0;

  const avgBookedDailyRateNext30Days =
    next30DaysBookedDaysCount !== 0
      ? Math.round(
          next30DaysRates.reduce(
            (cur, rate) =>
              rate.status === 'booked' || rate.status === 'recentlyBooked' ? cur + rate.rate : cur,
            0
          ) / next30DaysBookedDaysCount
        )
      : 0;

  return {
    avgDailyRateNext30Days,
    occupancyRateNext30Days,
    avgAvailableDailyRateNext30Days,
    avgBookedDailyRateNext30Days,
  };
};

export const getUnlockedMarketLife = (ended_at_dates: string[]): number => {
  const endedAtDate = new Date(ended_at_dates[ended_at_dates.length - 1]);
  // calculate difference in days between endedAtDate and today
  const daysLeft: number = moment(endedAtDate).diff(moment(), 'days');
  return daysLeft;
};

export const getCountryDataFromCountryCode = (countryCode: string) => {
  let desiredData;
  countryListWithCode.map(countryData => {
    if (countryData.code === countryCode) {
      desiredData = countryData;
    }
  });
  return desiredData;
};

export const abbreviateNumber = (value: number, putDecimal: boolean = true): string => {
  if (value == null || value === undefined) {
    return '';
  }

  let newValue: number | string = value;

  // thousands, millions, billions
  const suffixes = ['', 'K', 'M', 'B', 'T'];
  let suffixNum: number = 0;

  while (Number(newValue) >= 1000) {
    newValue /= 1000;
    suffixNum++;
  }

  if (putDecimal) {
    // Check if the value is an integer before adding decimal
    newValue = Number.isInteger(newValue) ? newValue.toString() : newValue.toFixed(1);
  } else {
    newValue = newValue.toFixed(0);
  }

  newValue += suffixes[suffixNum];

  return newValue;
};

export const checkIfGooglePlacesSessionValid = (
  googleAutocompleteSessionTokenTimeStamp: null | number
) => {
  if (googleAutocompleteSessionTokenTimeStamp) {
    const timeSpent = (Date.now() - googleAutocompleteSessionTokenTimeStamp) / 1000;
    // console.log("===Time Spent: ", timeSpent)
    return timeSpent < 60 * 2.5;
  }
  return false;
};

export const getClusterGeoJSONObject = (listingID: string, lat: number, lng: number) => {
  return {
    type: 'Feature',
    properties: { cluster: true, crimeId: listingID, category: 'listing' },
    geometry: {
      type: 'Point',
      coordinates: [lng, lat],
    },
  };
};

export const getMarketingTrackers = () => {
  let [lang, page, type, region] = ['', '', '', ''];
  const data = localStorage.getItem('marketing-trackers');
  if (data) {
    const marketingTrackers = JSON.parse(data);
    [lang, page, type, region] = [
      marketingTrackers.lang,
      marketingTrackers.page,
      marketingTrackers.type,
      marketingTrackers.region,
    ];
  }
  return [lang, page, type, region];
};

export const mapOptions = (
  map,
  showZoomButton: boolean = true,
  zoomButtonPosition: string = 'LEFT_BOTTOM'
) => {
  return {
    styles: mapStyles,
    fullscreenControl: false,
    zoomControlOptions: {
      position: map.ControlPosition[zoomButtonPosition],
    },
    zoomControl: showZoomButton ? true : false,
    clickableIcons: false,
    contextMenu: false,
  };
};

export const getKeyMetricsValByPercentile = (
  listings: Listing[],
  metricsKey: string,
  percentile: number = 0.5
) => {
  let median = -1;
  let values: number[] = [];
  listings.forEach(listing => {
    listing[`${metricsKey}`] &&
      !isNaN(listing['activeDaysCount']) &&
      listing['activeDaysCount'] >= 90 &&
      values.push(listing[`${metricsKey}`]);
  });
  if (values.length > 0) {
    median = Math.round(d3.quantile(values, percentile));
  }
  return median;
};

export const getSupplyByPropertyRevenue = (
  listings: Listing[],
  currency: string,
  cachedData: { [key: string]: number } | null = null
) => {
  let bedroomDistro = {
    '0': [],
    '1': [],
    '2': [],
    '3': [],
    '4': [],
    '5': [],
    '6+': [],
    rooms: [],
  } as { [key: string]: Listing[] };

  if (!cachedData) {
    listings.forEach((listing: Listing) => {
      if (
        !isNaN(Number(listing.activeDaysCount)) &&
        listing.activeDaysCount >= 90 &&
        ((listing.room_type && listing.room_type === 'entire_home') ||
          (listing.property_type && listing.property_type === 'condo')) &&
        (listing.bedrooms == 'Studio' || !isNaN(Number(listing.bedrooms)))
      ) {
        if (listing.bedrooms == 'Studio') {
          bedroomDistro['0'].push(listing);
        } else if (Number(listing.bedrooms) >= 6) {
          bedroomDistro['6+'].push(listing);
        } else {
          bedroomDistro[listing.bedrooms].push(listing);
        }
      } else if (
        listing.room_type &&
        (listing.room_type === 'private_room' ||
          listing.room_type === 'hotel_room' ||
          listing.room_type === 'shared_room')
      ) {
        bedroomDistro['rooms'].push(listing);
      }
    });
  }

  const calculateMedianRevenue = (listings: Listing[]) => {
    const medianAdrLTM = getKeyMetricsValByPercentile(listings, 'adrLTM');
    const medianOccupancyRateLTM = getKeyMetricsValByPercentile(listings, 'occupancyRateLTM');
    const medianRevenueFromCleaningFeeLTM = getKeyMetricsValByPercentile(
      listings,
      'revenueFromCleaningFeeLTM'
    );
    const revenue = Math.round(
      medianAdrLTM * (medianOccupancyRateLTM / 100) * 365 + medianRevenueFromCleaningFeeLTM
    );
    return revenue;
  };

  const result = Object.keys(cachedData ? cachedData : bedroomDistro).map(key => {
    return {
      keyShort: getUserFriendlyPropertySizeName(key, true),
      keyLong: getUserFriendlyPropertySizeName(key),
      value: convertCurrency(
        currency,
        cachedData ? cachedData[key] : calculateMedianRevenue(bedroomDistro[key])
      ),
    };
  });

  return result;
};

export const isLeapYear = (year: number) => {
  if (year % 400 === 0) {
    return true;
  } else if (year % 100 === 0) {
    return false;
  } else if (year % 4 === 0) {
    return true;
  }
  return false;
};

export const fetchMonthlyHistoricalData = async (url: string, auth: boolean = true) => {
  try {
    const data = await callApi(url, {}, auth);
    return data;
  } catch (err) {
    console.log('Error while calling getPastPricings: ', err);
    return null;
  }
};

export const processMonthlyHistoricalData = data => {
  const resultObj = {
    daily_past_pricings: {},
    monthly_past_pricings: {},
    weekly_past_pricings: {},
  };

  data.forEach(({ message }) => {
    resultObj['daily_past_pricings'] = {
      ...resultObj['daily_past_pricings'],
      ...message['daily_past_pricings'],
    };
    resultObj['monthly_past_pricings'] = {
      ...resultObj['monthly_past_pricings'],
      ...message['monthly_past_pricings'],
    };
    resultObj['weekly_past_pricings'] = {
      ...resultObj['weekly_past_pricings'],
      ...message['weekly_past_pricings'],
    };
  });

  return resultObj;
};

export const isListingLegacy = (listing: Listing | ListingLegacy): listing is ListingLegacy => {
  try {
    return listing.hasOwnProperty('isLegacy');
  } catch (err) {
    return false;
  }
};

export const getStartingEndingDate = (date: any, full: boolean = false): string => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  if (!date) return '';

  const yearMonthArray = date.split('-');
  const year = yearMonthArray[0];
  const fullMonth = monthNames[~~yearMonthArray[1] - 1]; //~~ -> converts into an integer
  const shortMonth = fullMonth.substring(0, 3);
  return full ? fullMonth + ', ' + year : shortMonth + ', ' + year;
};

export const calculateMoMChange = (
  data: ADR[] | OccupancyRate[] | Revenue[] | TempObject[] | RechartsDataFormat[],
  metricsKey: string
) => {
  let momChange: null | number = null;

  if (data.length === 0) return momChange;

  if (
    data[data.length - 1][metricsKey] !== 'missing' &&
    data[data.length - 1][metricsKey] !== 'inactive' &&
    data[data.length - 2][metricsKey] !== 'missing' &&
    data[data.length - 2][metricsKey] !== 'inactive'
  ) {
    momChange = data[data.length - 1][metricsKey] - data[data.length - 2][metricsKey];
  }

  if (data[data.length - 2][metricsKey] > 0 && momChange !== null) {
    momChange = Math.round((momChange / data[data.length - 2][metricsKey]) * 100);
  }

  return momChange;
};

export const getBannerHeight = (isMobile: boolean) => {
  if (isMobile) {
    return TOP_BANNER_PADDING_MOBILE;
  }
  return TOP_BANNER_PADDING;
};

export const extractNumericValue = (formattedValue: string, notNumberReturnValue: any = NaN) => {
  // Remove any non-digit characters (like commas, currency symbols, etc.)
  if (!formattedValue) return notNumberReturnValue;

  const numericValue = formattedValue.replace(/[^\d.-]/g, '');
  // Convert the extracted string to a number
  const numericValueAsNumber = parseFloat(numericValue);

  return isNaN(numericValueAsNumber) ? notNumberReturnValue : numericValueAsNumber;
};

export const getDistance = (fromLatitude, fromLongitude, toLatitude, toLongitude) => {
  const earthRadiusMiles = 3958.8; // Earth's radius in miles

  // Convert latitude and longitude from degrees to radians
  const fromLatRad = (fromLatitude * Math.PI) / 180;
  const fromLongRad = (fromLongitude * Math.PI) / 180;
  const toLatRad = (toLatitude * Math.PI) / 180;
  const toLongRad = (toLongitude * Math.PI) / 180;

  // Calculate the differences between coordinates
  const latDiff = toLatRad - fromLatRad;
  const longDiff = toLongRad - fromLongRad;

  // Calculate the distance using Haversine formula
  const a =
    Math.sin(latDiff / 2) ** 2 +
    Math.cos(fromLatRad) * Math.cos(toLatRad) * Math.sin(longDiff / 2) ** 2;

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  // Calculate the distance in miles
  const distance = earthRadiusMiles * c;

  return distance;
};

export const getRateStatus = (rate: string) => {
  if (rate?.includes(':b')) {
    return 'booked';
  } else if (rate?.includes(':rb')) {
    return 'recentlyBooked';
  } else if (rate?.includes(':a')) {
    return 'available';
  } else {
    return 'inactive';
  }
};

export const calculateBounds = (path: Coordinates[][]) => {
  let minLat = Infinity;
  let maxLat = -Infinity;
  let minLng = Infinity;
  let maxLng = -Infinity;

  path.forEach(polygon => {
    polygon.forEach(point => {
      if (!isNaN(point.lat)) {
        minLat = Math.min(minLat, point.lat);
        maxLat = Math.max(maxLat, point.lat);
      }
      if (!isNaN(point.lng)) {
        minLng = Math.min(minLng, point.lng);
        maxLng = Math.max(maxLng, point.lng);
      }
    });
  });

  return { minLat, maxLat, minLng, maxLng };
};


export const isWithinBounds = (point: Coordinates, bounds: GoogleMapReact.Bounds) => {
  const latInRange =
    (point.lat >= bounds.sw.lat && point.lat <= bounds.ne.lat) ||
    (point.lat <= bounds.sw.lat && point.lat >= bounds.ne.lat);

  const lngInRange =
    bounds.sw.lng <= bounds.ne.lng
      ? // Normal case: Bounds don't cross antimeridian
        point.lng >= bounds.sw.lng && point.lng <= bounds.ne.lng
      : // Bounds cross antimeridian
        point.lng >= bounds.sw.lng || point.lng <= bounds.ne.lng;

  return latInRange && lngInRange;
};

export const isPointWithinBounds = (
  point: string | { lat: number; lng: number },
  bounds: GoogleMapReact.Bounds
) => {
  // Function to normalize longitude to range [-180, 180]
  const normalizeLongitude = (lng: number) => {
    while (lng < -180) lng += 360;
    while (lng > 180) lng -= 360;
    return lng;
  };

  // Parse the point string to extract latitude and longitude
  const parsePoint = (point: string) => {
    const [lng, lat] = point
      .replace('POINT(', '')
      .replace(')', '')
      .split(' ')
      .map(parseFloat);
    return { lat, lng: normalizeLongitude(lng) };
  };

  // Normalize bounds' longitudes
  bounds.sw.lng = normalizeLongitude(bounds.sw.lng);
  bounds.ne.lng = normalizeLongitude(bounds.ne.lng);

  // Parse the input point
  let parsedPoint;
  if (point && typeof point === 'string') {
    parsedPoint = parsePoint(point);
  } else if (point && typeof point === 'object') {
    parsedPoint = { lat: point?.lat, lng: point?.lng };
  } else {
    return false;
  }

  // Check if the parsed point is within the bounds
  const latInRange = parsedPoint.lat >= bounds.sw.lat && parsedPoint.lat <= bounds.ne.lat;
  const lngInRange =
    bounds.sw.lng <= bounds.ne.lng
      ? parsedPoint.lng >= bounds.sw.lng && parsedPoint.lng <= bounds.ne.lng
      : parsedPoint.lng >= bounds.sw.lng || parsedPoint.lng <= bounds.ne.lng;

  return latInRange && lngInRange;
};

export const checkIfDateExpired = (end_date_str: string): boolean => {
  const end_date = new Date(end_date_str);
  const current_date = new Date();
  const time_difference = end_date.getTime() - current_date.getTime();
  const days_difference = Math.floor(time_difference / (1000 * 60 * 60 * 24));
  return days_difference < 0;
};


export const updateDynamoDBForUserVerification = (
  market: string,
  setSubscriptionModalOpen: React.Dispatch<React.SetStateAction<boolean>>,
  user: User
) => {
  // This Function is responsible to track User data verification step and show subscription popup after 20 sec of user verification step
  const isDynamoDBUpdated: Boolean = trackUserDataVerificationAttempt(market);
  let doesUserOpenSubscriptionModalIntentionally = window.localStorage.getItem(
    'userOpenSubscriptionModalIntentionally'
  );

  if (isDynamoDBUpdated && !doesUserOpenSubscriptionModalIntentionally) {
    let credits = user.credits || 0;
    let estimatorCredits = user.estimatorCredits || 0;

    if (credits == 0 || estimatorCredits == 0) {
      setTimeout(() => {
        setSubscriptionModalOpen(true);
      }, 20000);
    }
  }
};

export const updateUserOpenedSubscriptionModalInDynamoDB = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { subscriptionModalOpened: true };
  callApi(api, { queryParams: config }, true);
};

export const trackUserSearchedIndividualListingThroughLink = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { UserSearchedIndividualListingThroughLink: true };
  callApi(api, { queryParams: config }, true);
};

export const trackFilterActivation = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { filterActivated: true };
  callApi(api, { queryParams: config }, true);
};

export const trackConfigurableOverviewGraphActivation = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { overviewGraphConfigured: true };
  callApi(api, { queryParams: config }, true);
};

export const trackLast3YearsDataInterest = () => {
  const api =
    'https://qdo7trqmn7.execute-api.us-east-2.amazonaws.com/default/trackProductAnalytics';
  const config = { last3YearsDataInterest: true };
  callApi(api, { queryParams: config }, true);
};

export const parseGuest = (input: any): ParsedGuest => {
  if (!input) {
    return {} as ParsedGuest;
  }
  return input;
};

export const brightConsole = () => {
  return {
    log: (...data) =>
      console.log(
        '\n\n%cSEARCH: ',
        'color: cyan; font-weight: bold; font-size: 20px;',
        ...data,
        '\n\n\n'
      ),
    error: (...data) =>
      console.log(
        '\n\n%cERROR: ',
        'color: red; font-weight: bold; font-size: 20px;',
        ...data,
        '\n\n\n'
      ),
  };
};


export const parseMessageHistoricalData = (message: CachedMarketDataTypes) => {
  const newHistoricalDataObj: any = {};
  if (message && message.historical_monthly_performance) {
    for (const key in message.historical_monthly_performance) {
      newHistoricalDataObj[key] = convertKeys(message.historical_monthly_performance[key]);
    }
  }
  message.historical_monthly_performance = newHistoricalDataObj;

  const formatSupplyBreakdown = (breakdown: any) => {
    const formattedBreakdown: any = {};
    for (const key in breakdown) {
      formattedBreakdown[key] = { supply: breakdown[key] };
    }
    return formattedBreakdown;
  };

  if (message && message.supply_breakdown && message.supply_breakdown.accommodates) {
    message.supply_breakdown.accommodates = formatSupplyBreakdown(
      message.supply_breakdown.accommodates
    );
  }

  if (message && message.supply_breakdown && message.supply_breakdown.active_days_count) {
    message.supply_breakdown.active_days_count = formatSupplyBreakdown(
      message.supply_breakdown.active_days_count
    );
  }

  return message;
};

export const findKeyByValue = (obj: any, value: any) => {
  for (const key in obj) {
    if (obj[key] === value) {
      return key;
    }
  }

  return null;
};

export const getUniqueUserId = (user: User) => {
  let uniqueUserId: string | null = null;

  try {
    uniqueUserId =
      String(user.email.split('@')[0]).replace(/[+]/g, '_') + '__' + user.userSignUpDay.toString();
  } catch (err) {
    console.log('Error while setting an unique user id: ', err);
  }
  return uniqueUserId;
};

export const calculateKeyMetrices = (
  metrics: string[],
  listing: ListingVal,
  type: string,
  metricsKpiObjects: { [key: string]: { [key: string]: number[] } }
) => {
  const inputOutMetricsNameMap = {
    occupancyRateLTM: 'occupancyRate',
    revenuePotential: 'revenue',
    adrLTM: 'adr',
    revPAN: 'revPAN',
    revenueFromCleaningFeeLTM: 'revenueFromCleaningFeeLTM',
  };

  metrics.forEach(metric => {
    if (!metricsKpiObjects[type][inputOutMetricsNameMap[metric]]) {
      metricsKpiObjects[type][inputOutMetricsNameMap[metric]] = [listing[metric]] as number[];
    } else {
      metricsKpiObjects[type][inputOutMetricsNameMap[metric]].push(listing[metric]);
    }
  });
};

export const calculatePercentile = (data, percentile = 0.5) => {
  let median = -1;
  let values: number[] = [];
  data.forEach(item => {
    item && values.push(item);
  });
  if (values.length > 0) {
    median = Math.round(d3.quantile(values, percentile));
  }
  return median;
};

export const intializeAmenityObject = () => {
  return {
    kitchen: {
      type: 'basic',
    },
    parking: {
      type: 'basic',
    },
    wifi: {
      type: 'basic',
    },
    heating: {
      type: 'basic',
    },
    dryer: {
      type: 'basic',
    },
    tv: {
      type: 'basic',
    },
    washer: {
      type: 'basic',
    },
    bbq_grill: {
      type: 'basic',
    },
    breakfast: {
      type: 'basic',
    },
    fireplace: {
      type: 'advanced',
    },
    pool: {
      type: 'advanced',
    },
    hot_tub: {
      type: 'advanced',
    },
    gym: {
      type: 'advanced',
    },
    ac: {
      type: 'advanced',
    },
  };
};


export const calculateAmenitySupplyByPropertySize = (
  listings: { [key: string]: ListingVal },
  amenityObject
) => {
  const distributeAmenityByPropertySize = (listingID, listingVal, bedroomCategory) => {
    Object.keys(amenityObject).forEach(amenity => {
      if (!amenityObject[amenity].hasOwnProperty('supply')) {
        amenityObject[amenity]['supply'] = initializeAmenityDistributionByPropertySize();
      }

      const presentOrAbsent = listingVal.amenities[amenity] ? 'present' : 'absent';
      amenityObject[amenity]['supply'][bedroomCategory][presentOrAbsent].push(listingID);

      amenityObject[amenity]['supply'][bedroomCategory]['total']++;
    });
  };

  Object.keys(listings).forEach(listingID => {
    const listingVal = listings[listingID];
    const roomType = listingVal.room_type;
    const bedrooms = listingVal.bedrooms;
    try {
      if (roomType === 'entire_home') {
        if (bedrooms === '0' || bedrooms === 'Studio') {
          distributeAmenityByPropertySize(listingID, listingVal, 'studio');
        } else if (Number(bedrooms) >= 6) {
          distributeAmenityByPropertySize(listingID, listingVal, '6+');
        } else {
          distributeAmenityByPropertySize(listingID, listingVal, bedrooms);
        }
      }
    } catch (e) {
      console.error('Ignore', e);
    }
  });
};

export const setPropertySizeToUseForRevPanChange = (amenityObject, proportionThreshold = 0.05) => {
  /*
    The following code represents a core business logic
    to choose the size of bedrooms to use for calculating revPAN impact of each amenity.

    Why are we choosing a single property size (bedroom)?
    To remove biases that can skew the revPAN impact of each amenity based on property type and size.

    Bedroom Selection Algorithm ordered by Priority:
    1. Bedroom with the highest amenity_absent proportion
      - Skip bedroom if either all listings have the amenity or non have it.
    2. Bedroom with the highest absolute supply of the amenity when absence proportions are within a threshold of 5%
      - To increase the number of samples for calculating median

    Proportion Threshold:
      - A threshold to determine when absence proportions are considered close.
      - If the difference in absence proportions is within this threshold, consider supply.

  */

  Object.keys(amenityObject).forEach(amenity => {
    const bedroomCategories = Object.keys(amenityObject[amenity].supply);

    let chosenBedroom = bedroomCategories[0];
    let highestAbsenceProportion = 0;

    // TODO: reduce the complexity of the follwoing loop from O(n^2) to O(n)
    bedroomCategories.forEach(bedroomCategory => {
      const absentCount = amenityObject[amenity].supply[bedroomCategory].absent.length;
      const totalCount = amenityObject[amenity].supply[bedroomCategory].total;
      const currentAbsenceProportion = absentCount / totalCount || 0;
      amenityObject[amenity].supply[bedroomCategory]['absentProportion'] = currentAbsenceProportion;

      // Skip bedrooms with absence proportion 1 or 0
      if (currentAbsenceProportion === 1 || currentAbsenceProportion === 0) {
        return;
      }

      if (currentAbsenceProportion > highestAbsenceProportion) {
        highestAbsenceProportion = currentAbsenceProportion;
        chosenBedroom = bedroomCategory;

        bedroomCategories.forEach(bedroom => {
          const absentCount = amenityObject[amenity].supply[bedroom].absent.length;
          const totalCount = amenityObject[amenity].supply[bedroom].total;
          const absenceProportion = absentCount / totalCount || 0;

          if (
            Math.abs(absenceProportion - highestAbsenceProportion) <= proportionThreshold &&
            amenityObject[amenity].supply[bedroom].present.length >
              amenityObject[amenity].supply[chosenBedroom].present.length
          ) {
            chosenBedroom = bedroom;
          }
        });
      }
    });

    amenityObject[amenity]['chosenBedroom'] = chosenBedroom;
  });
};

export const calculateRevPanChange = (listings: { [key: string]: ListingVal }, amenityObject) => {
  const returnObj = Object.keys(amenitiesObject).reduce((result, key) => {
    result[key] = {};
    return result;
  }, {});

  Object.keys(amenityObject).forEach(amenity => {
    const bedroomToUse = amenityObject[amenity].chosenBedroom;
    const revPanForListingsWithAmenity: number[] = [];
    const revPanForListingsWithoutAmenity: number[] = [];

    amenityObject[amenity].supply[bedroomToUse].present.forEach(listingID => {
      const listing = listings[listingID];
      const revPAN = listing.revPAN;
      revPanForListingsWithAmenity.push(revPAN);
    });

    amenityObject[amenity].supply[bedroomToUse].absent.forEach(listingID => {
      const listing = listings[listingID];
      const revPAN = listing.revPAN;
      revPanForListingsWithoutAmenity.push(revPAN);
    });

    const medianRevPanForListingsWithAmenity = d3.median(revPanForListingsWithAmenity);
    const medianRevPanForListingsWithoutAmenity = d3.median(revPanForListingsWithoutAmenity);
    let revPanChange = Math.round(
      ((medianRevPanForListingsWithAmenity - medianRevPanForListingsWithoutAmenity) /
        medianRevPanForListingsWithoutAmenity) *
        100
    );

    /*
   Moderations
   - If RevPAN change is negative, it's capped at 0
   - for Advanced amenities RevPAN change is > 100%, it's capped at 100%
   - for Basic amenities RevPAN change is > 50%, it's capped at 50%

   */

    revPanChange = revPanChange < 0 ? 0 : revPanChange;

    if (amenityObject[amenity].type == 'basic') {
      revPanChange = revPanChange > 50 ? 50 : revPanChange;
    } else {
      revPanChange = revPanChange > 100 ? 100 : revPanChange;
    }

    returnObj[amenity]['revPanChange'] = revPanChange;
  });

  return returnObj;
};

export const calculateAvailabilityWiseTotalListings = (
  listingID: string,
  listings: { [key: string]: ListingVal },
  calculateAvailabilityWiseTotalListings: { [key: string]: { [key: string]: number } }
) => {
  const listing = listings[listingID];
  const activeDays: any = listing.activeDaysCount;
  let selectedRange: string | null = '-';

  for (const range in calculateAvailabilityWiseTotalListings) {
    const [start, end] = range.split('-').map(Number);
    if (activeDays >= start && activeDays <= end) {
      selectedRange = range;
      break;
    }
  }

  if (selectedRange != '-') {
    if (calculateAvailabilityWiseTotalListings[selectedRange]['supply']) {
      calculateAvailabilityWiseTotalListings[selectedRange]['supply'] =
        calculateAvailabilityWiseTotalListings[selectedRange]['supply'] + 1;
    } else {
      calculateAvailabilityWiseTotalListings[selectedRange]['supply'] = 1;
    }
  }
};

export const getRedirectedDiscoveryMarketCountryCode = (userCountryCode: string) => {
  if (Object.keys(AVAILABLE_COUNTRY).includes(userCountryCode)) {
    return userCountryCode;
  }
  return 'US';
};

export const deepCopyObject = (obj: any) => {
  return JSON.parse(JSON.stringify(obj));
};

export const clearApiCache = async () => {
  const cacheName = 'api_cache';
  try {
    await caches.delete(cacheName);
  } catch (error) {
    console.error(`Failed to clear cache '${cacheName}':`, error);
  }
};

export const isMarketBeachfront = (listings: ListingsProp) => {
  const totalListingsCount = Object.keys(listings.data).length;

  const beachfrontListingsCount = Object.values(listings.data).reduce((count, listing) => {
    if (listing.amenities && listing.amenities.beachfront === true) {
      return count + 1;
    } else {
      return count;
    }
  }, 0);

  const beachfrontListingsShare = (beachfrontListingsCount / totalListingsCount) * 100;
  return beachfrontListingsShare >= 5;
};

export const sendFormSubmissionEmail = async (receiverEmail, content1, title) => {
  let URL =
    'https://y7kp4qpcfh.execute-api.us-east-2.amazonaws.com/default/sendFormSubmissionEmail';
  const config = {
    receiverEmail: encodeURIComponent(receiverEmail),
    content: content1,
    title: title,
  };
  await callApi(URL, { queryParams: config }, false);
};

export const updateEnterpriseLeadsInGoogleSheet = async (sheet_name, data) => {
  let URL =
    'https://7q8vk5fb3g.execute-api.us-east-2.amazonaws.com/default/updateEnterpriseLeadsInGoogleSheet';
  const config = { sheet_name: sheet_name, data: encodeURIComponent(data) };
  await callApi(URL, { queryParams: config }, false);
};

export const getTodayDateTimeUTC = () => {
  const now = new Date();

  // Get UTC versions of year, month, date, hours, minutes, and seconds
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // Adding 1 to month since it is zero-based
  const date = String(now.getUTCDate()).padStart(2, '0');
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');

  // Format date and time in UTC
  const formattedDateTimeUTC = `${year}/${month}/${date} ${hours}:${minutes}:${seconds}`;

  return formattedDateTimeUTC;
};

export const getMalaysianDateTime = () => {
  const malaysianTimeZone = 'Asia/Kuala_Lumpur';
  const date = new Date();

  // Format date to get month and day
  const options: Intl.DateTimeFormatOptions = {
    month: 'long',
    day: 'numeric',
    timeZone: malaysianTimeZone,
  };

  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

  // Get the hour and minute in Malaysian time
  const timeOptions: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    hour12: true,
    timeZone: malaysianTimeZone,
  };

  const formattedTime = new Intl.DateTimeFormat('en-US', timeOptions).format(date);

  return `${formattedDate} - ${formattedTime}`;
};

export const checkPromocodeValidity = async (
  promocode: string,
  promoCodeDiscountsDict: any,
  returnValidPromoCode: boolean = false
) => {
  if (!promocode || !(promocode in promoCodeDiscountsDict)) {
    return returnValidPromoCode ? '' : false;
  }

  let isPromoCodeValid = false;

  const url = 'https://61psikryqf.execute-api.us-east-2.amazonaws.com/default/activateCouponCode';
  const couponValidationConfig = {
    queryParams: {
      promoCode: promoCodeDiscountsDict[promocode].id,
      operation: 'validate',
    },
  };
  const res = await callApi(url, couponValidationConfig, false);

  if (res.message) {
    isPromoCodeValid = res.message.valid;
  }
  if (res.error) {
    isPromoCodeValid = false;
  }

  if (!returnValidPromoCode) {
    return isPromoCodeValid;
  }

  return isPromoCodeValid ? promocode : '';
};

export const calculateCouponChange = (
  currentPromoCode: string,
  promoCodeDiscountsDict: any,
  subscriptionPriceAccordingToUserLocalCurrency: any,
  duration: string,
  setDiscountedPrice: any,
  productName = 'expert'
) => {
  if (!currentPromoCode) {
    return 0;
  }
  currentPromoCode = currentPromoCode.toUpperCase();
  let newDiscountedPricing = 0;
  const currentPromoCodeObj = promoCodeDiscountsDict[currentPromoCode] || {};

  if (!currentPromoCodeObj) {
    return 0;
  }

  const currentPrice = Number(subscriptionPriceAccordingToUserLocalCurrency[productName][duration]);

  if (currentPromoCodeObj.type === 'percent') {
    newDiscountedPricing =
      currentPrice - currentPrice * (Number(promoCodeDiscountsDict[currentPromoCode].amount) / 100);
  } else if (currentPromoCodeObj.type === 'fixed-off') {
    newDiscountedPricing = currentPrice - Number(currentPromoCodeObj.amount);
  } else if (currentPromoCodeObj.type === 'fixed-price') {
    newDiscountedPricing = Number(currentPromoCodeObj.amount);
  }
  setDiscountedPrice && setDiscountedPrice(_ => Number(newDiscountedPricing.toFixed(2)));
  return Number(newDiscountedPricing.toFixed(2));
};

export const getDummyMarketURL = dummyMarket => {
  let path = `/airbnb-data/${dummyMarket['country'].replaceAll(' ', '%20')}/${dummyMarket[
    'city'
  ].replaceAll(' ', '%20')}/${dummyMarket['district'].replaceAll(' ', '%20')}`;
  return path.toLowerCase();
};

export const checkUserTailorMarketAccess = (user, search) => {
  if (user?.email == search?.data?.created_by) {
    if (user.subscriptionPlan == 'expert' || user.subscriptionPlan == 'scale') {
      return true;
    } else {
      return false;
    }
  } else {
    if (
      user.userName == 'Trial' &&
      search.data.created_by == '' &&
      search.data.visibility == 'private'
    ) {
      // User is not logged in and created a tailor region
      return false;
    } else {
      //not a tailor region
      return true;
    }
  }
};

export const changePercentageToDecimal = perc => {
  let percentage = parseInt(perc);
  return percentage / 100;
};


export const checkListingRecentlyAdded = (
  listing: Listing,
  isBookingComListing: boolean = false
) => {
  // temp condition for booking.com listings
  if (isBookingComListing && listing['activeDaysCount'] < 365) {
    return true;
  }
  const dateBefore90Days = convertDateToString(dateDeforeNDays(90));
  if (listing.added_on && listing.added_on > dateBefore90Days) {
    return true;
  }
  return false;
};

export const checkListingInactive = (listing: Listing, isBookingComListing: boolean = false) => {
  const isListingRecentlyAdded = checkListingRecentlyAdded(listing, isBookingComListing);
  if (isListingRecentlyAdded) {
    return false;
  }
  if (!listing.activeDaysCount || listing.activeDaysCount < 90) {
    return true;
  }
  return false;
};

export const checkListingUnlisted = (listing: Listing, isBookingComListing: boolean = false) => {
  const isListingRecentlyAdded = checkListingRecentlyAdded(listing, isBookingComListing);
  if (isListingRecentlyAdded) {
    return false;
  }

  const isListingInactive = checkListingInactive(listing, isBookingComListing);
  if (isListingInactive) {
    return false;
  }

  if (listing.last_seen && listing.last_seen < '2024-10-14') {
    return true;
  }

  return false;
};

export const checkAdrAnomaly = (listingADR: number | null, referenceADR: number | null) => {
  if (!listingADR || !referenceADR) {
    return false;
  }
  return listingADR >= referenceADR * 5;
};

export const filterActiveListings = (listings: Listing[] | VisibleListingsProp, type = 'list') => {
  if (type === 'list') {
    return (listings as Listing[]).filter(
      listing => listing.activeDaysCount && listing.activeDaysCount >= 90
    );
  } else {
    return {
      data: (listings as VisibleListingsProp).data.filter(
        listing => listing.activeDaysCount && listing.activeDaysCount >= 90
      ),
      loading: (listings as VisibleListingsProp).loading,
    } as VisibleListingsProp;
  }
};

export const getPolygonPaths = (polygonRaw: string, multiPolygonRaw: string) => {
  const polygonArr: Coordinates[][] = processPolygon(polygonRaw, multiPolygonRaw);
  let paths: Coordinates[][] = [];
  if (polygonArr.length > 0) {
    polygonArr.forEach((polygon: Coordinates[], _: number) => paths.push(polygon));
  }
  return paths;
};

export const isUserFromAmericanContinent = () => {
  const americanTimeZones = [
    'America/New_York',
    'America/Chicago',
    'America/Denver',
    'America/Los_Angeles', // North America
    'America/Sao_Paulo',
    'America/Buenos_Aires',
    'America/Bogota', // South America
    'America/Havana',
    'America/Santo_Domingo', // Caribbean
    'America/Mexico_City',
    'America/Guatemala',
    'America/Panama', // Central America
  ];

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return americanTimeZones.includes(timeZone);
};

export const removeQueryParamsFromURL = () => {
  let url = new URL(window.location.href);
  url.search = '';
  window.history.replaceState({}, document.title, url.toString());
};

export const getPercentage = (newValue: number, oldValue: number) => {
  if (oldValue === 0) {
    return 0;
  }
  return ((newValue - oldValue) / oldValue) * 100;
};

export const isCurrentPlanSubscribed = (plan, currentActivePlan) => {
  return plan == currentActivePlan;
};

export const checkIfUserLoggedIn = (userEmail: string) => {
  return userEmail !== 'Trial';
};

export const storeVisitedMarketInLocalStorage = newSearchObj => {
  const newMarket = {
    district: newSearchObj.name,
    city: newSearchObj.city,
    country: newSearchObj.country,
    displayName: newSearchObj.displayName,
  };

  const existingMarketsString = localStorage.getItem('visited-markets');
  const existingMarkets = existingMarketsString ? JSON.parse(existingMarketsString) : [];

  const isMarketPresent = existingMarkets.some(
    market =>
      market.district === newMarket.district &&
      market.city === newMarket.city &&
      market.country === newMarket.country
  );

  if (!isMarketPresent) {
    existingMarkets.push(newMarket);
    localStorage.setItem('visited-markets', JSON.stringify(existingMarkets));
  }
};

export const getVisitedMarketsFromLocalStorage = () => {
  const existingMarketsString = localStorage.getItem('visited-markets');
  return existingMarketsString ? JSON.parse(existingMarketsString) : [];
};

export const getRedirectionLink = (
  countryParam: string = '',
  cityParam: string = '',
  districtParam: string = ''
) => {
  const paramStr = `${countryParam}/${cityParam}/${districtParam}`;
  return `/airbnb-data/${paramStr}`;
};

export const getDynamicMarkers = async (
  marketID: number | string,
  marketBoundary: string,
  bounds: Bounds,
  isUserAllowed,
  filterVal: FilterVal | null,
  page = 1,
  returnSupply = false,
  setFilterCacheLoading: any = null,
  listingSortingKey: string
) => {
  // const url = 'https://k6wf64h501.execute-api.us-east-2.amazonaws.com/default/getDynamicMarkers';
  const url = 'https://xnxq16nesj.execute-api.us-east-2.amazonaws.com/default/getMapListings';

  const { filters } = filterVal ? parseFilterValToApiResponse(filterVal) : { filters: {} };

  let markerParam = {
    market_id: marketID,
    neLat: bounds.northEast.lat,
    neLng: bounds.northEast.lng,
    swLat: bounds.southWest.lat,
    swLng: bounds.southWest.lng,
    page: page,
    marketPolygon: marketBoundary,
    sort_by: listingSortingKey,
  };

  if (returnSupply) {
    markerParam['return_supply'] = true;
  }

  if (!isEmpty(filters)) {
    markerParam['filters'] = filters;
  }

  if (isUserAllowed) {
    markerParam['limit'] = 9;
  }

  let listings = [] as Listing[];

  try {
    const response = await callApi(
      url,
      { body: markerParam, queryParams: { apiType: 'v2' } },
      true,
      false,
      '',
      'POST',
      true,
      undefined,
      true,
      true
    );

    if (response && response.status == 429) {
      return [];
    }

    if (response && response.message) {
      if (response.message?.is_cached === false) {
        setFilterCacheLoading(true);
      }
      listings = processListingData(response.message);
    }
  } catch (error) {
    console.error('Error fetching dynamic markers:', error);
  }

  return listings;
};

export const getBookingMarkers = async (
  marketID: number | string,
  marketBoundary: string,
  bounds: Bounds
) => {
  const url = 'https://120rhh5w7j.execute-api.us-east-2.amazonaws.com/prod/getBookingMarkers';

  let markerParam = {
    market_id: marketID,
    neLat: bounds.northEast.lat,
    neLng: bounds.northEast.lng,
    swLat: bounds.southWest.lat,
    swLng: bounds.southWest.lng,
    marketPolygon: marketBoundary,
    limit: 11,
  };

  let listings: any[] = [];

  try {
    const response = await callApi(url, { body: markerParam }, true, false, '', 'POST', true);

    if (response && response.message) {
      listings = processBookingListingData(response.message);
    }
  } catch (error) {
    console.error('Error fetching booking markers:', error);
  }

  return listings;
};


export const getTailoredRegionByTimezone = () => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timeZoneCoordinatesMap[timezone]) {
    return timeZoneCoordinatesMap[timezone];
  }

  const regionLocationMap = {
    Europe: { lat: 45.4642, lng: 9.19 }, // Milan, Europe
    UK: { lat: 51.5074, lng: -0.1278 }, // London, UK
    Africa: { lat: -33.9249, lng: 18.4241 }, // Cape Town, Africa
    Oceania: { lat: -33.8688, lng: 151.2093 }, // Sydney, Oceania
    Asia: { lat: -8.3405, lng: 115.092 }, // Bali, Asia (Exclude Middle East)
    'Middle East': { lat: 25.276987, lng: 55.296249 }, // Dubai, Middle East
  };

  // Check for common regions in timezone string and map to the appropriate region
  if (timezone.startsWith('Europe')) return regionLocationMap['Europe'];
  if (timezone.startsWith('Africa')) return regionLocationMap['Africa'];
  if (timezone === 'Europe/London') return regionLocationMap['UK'];
  if (timezone.startsWith('Australia')) return regionLocationMap['Oceania'];
  if (timezone.startsWith('Asia') && !isMiddleEastTimezone(timezone))
    return regionLocationMap['Asia'];
  if (isMiddleEastTimezone(timezone)) return regionLocationMap['Middle East'];

  // Default case if no region match
  return null;
};

export const roundFloat = (num: number, points: number = 2) => {
  let multiplier = 1;

  for (let i = 0; i < points; i++) {
    multiplier *= 10;
  }

  return Math.floor(num * multiplier) / multiplier;
};

export const beautifyDate = (dateStr: string) => {
  const date = new Date(dateStr);
  const day = date.toLocaleDateString('en-GB', { day: 'numeric' });
  const month = date.toLocaleDateString('en-GB', { month: 'long' });
  const year = date.toLocaleDateString('en-GB', { year: 'numeric' });
  return `${day} ${month}, ${year}`;
};

export const handleImageInput = (fileInput, maxSizeInMb: number = 10) => {
  return new Promise((resolve, reject) => {
    try {
      fileInput = Array.from(fileInput);
      const file = fileInput[0];

      // Check if the selected file is an image
      if (!file || !file.type.startsWith('image/')) {
        reject('File is not an image');
        return;
      }

      // Check if the image size is more than 10MB (10 * 1024 * 1024 bytes)
      const maxSize = maxSizeInMb * 1024 * 1024;
      if (file.size > maxSize) {
        reject('File size exceeds 10MB');
        return;
      }

      const reader = new FileReader();
      reader.onload = function(event) {
        const img = new Image();
        img.onload = function() {
          const maxDimension = 600;
          let width = img.width;
          let height = img.height;

          // Calculate aspect ratio
          if (width > height) {
            // Landscape image
            if (width > maxDimension) {
              height = Math.floor((height / width) * maxDimension);
              width = maxDimension;
            }
          } else {
            // Portrait or square image
            if (height > maxDimension) {
              width = Math.floor((width / height) * maxDimension);
              height = maxDimension;
            }
          }

          // Create a canvas to resize the image
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Set canvas size to new dimensions
          canvas.width = width;
          canvas.height = height;

          // Draw the image onto the canvas with the new dimensions
          ctx && ctx.drawImage(img, 0, 0, width, height);

          // Get the resized image as a base64 string (jpeg with quality 0.8)
          const base64String = canvas.toDataURL('image/webp', 0.8);
          resolve(base64String);
        };

        img.src = event.target?.result as any;
      };

      reader.onerror = function() {
        reject('Error reading file');
      };

      reader.readAsDataURL(file);
    } catch (err) {
      console.log('Error in image processing: ', err);
      reject('Processing Error!');
    }
  });
};

export const setPolygon = (
  map,
  maps,
  paths: Coordinates[][],
  strokeColor: string,
  fillColor: string,
  strokeOpacity = 0.8,
  strokeWeight = 2,
  fillOpacity = 0.12
) => {
  const polygon = new maps.Polygon({
    paths: paths,
    strokeColor: strokeColor,
    strokeOpacity: strokeOpacity,
    strokeWeight: strokeWeight,
    fillColor: fillColor,
    fillOpacity: fillOpacity,
  });
  polygon.setMap(map);

  return polygon;
};

export const calculateHistoricalTrends = (metricsHistoricalData, metric, percentile) => {
  try {
    if (!metricsHistoricalData) {
      return { yearlyYoYChange: {}, nextYearPredcition: 0 };
    }

    const key = `${metric}${percentile}`;
    const currentYear = metricsHistoricalData[metricsHistoricalData.length - 1].latestYear;
    const startYear = 2021; // Starting year as per requirement

    const parseData = () => {
      const result = {};

      // Loop over the data and transform it
      metricsHistoricalData.forEach(data => {
        // Dynamically generate years from startYear to the latest year (max of current year or data year)
        for (let year = startYear; year <= currentYear; year++) {
          const yearStr = year.toString();
          if (data[yearStr]) {
            if (!result[yearStr]) {
              result[yearStr] = {};
            }

            // Assign the monthly data to the respective year
            result[yearStr][data.month] = {
              revenue25: data[yearStr][`${metric}25`],
              revenue50: data[yearStr][`${metric}50`],
              revenue75: data[yearStr][`${metric}75`],
              revenue90: data[yearStr][`${metric}90`],
            };
          }
        }
      });

      return result;
    };

    const calculateYoYYearlyChange = parsedData => {
      const result = {};
      const years = Object.keys(parsedData).sort(); // Sort years in ascending order

      for (let i = 1; i < years.length; i++) {
        const currentYear = years[i];
        const previousYear = years[i - 1];

        // Find common months between consecutive years
        const commonMonths = Object.keys(parsedData[currentYear]).filter(month =>
          parsedData[previousYear].hasOwnProperty(month)
        );

        let totalYoYChange = 0;
        let monthCount = 0;

        commonMonths.forEach(month => {
          const currentRevenue = parsedData[currentYear][month][key];
          const previousRevenue = parsedData[previousYear][month][key];

          if (currentRevenue !== null && previousRevenue !== null) {
            // Avoid division by zero
            // Calculate YoY change for revenue50
            const yoyChange =
              ((currentRevenue - previousRevenue) / Math.max(previousRevenue, 1)) * 100;
            totalYoYChange += yoyChange;
            monthCount++;
          }
        });

        // Calculate average YoY change for the year
        const avgYoYChange = monthCount > 0 ? totalYoYChange / monthCount : 0;

        // Store the average YoY change for the year
        result[currentYear] = avgYoYChange;
      }

      return result;
    };

    // Usage
    const parsedData = parseData();
    const yearlyYoYChange = calculateYoYYearlyChange(parsedData);
    const currentYearYoYChange = yearlyYoYChange[currentYear];
    const previousYearYoYChange = yearlyYoYChange[currentYear - 1];
    const nextYearPredcition = Number(
      ((currentYearYoYChange + previousYearYoYChange) / 2).toFixed(2)
    );
    yearlyYoYChange[currentYear + 1] = nextYearPredcition;

    return { yearlyYoYChange, nextYearPredcition };
  } catch (err) {
    return { yearlyYoYChange: {}, nextYearPredcition: 0 };
  }
};
export const waitForPaymentProcessing = async (stripe, clientSecret) => {
  const maxRetries = 5;
  const delayMs = 3000;
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);
      const status = paymentIntent?.status;
      if (status === 'succeeded') {
        return true;
      }
      if (status === 'processing') {
        await new Promise(resolve => setTimeout(resolve, delayMs));
        continue;
      }
      return false;
    } catch (e) {
      await new Promise(resolve => setTimeout(resolve, delayMs));
    }
  }
  return false;
};

export const confirmCardPaymentRecursively = async (stripe, clientSecret) => {
  const confirmCardPaymentResp = await stripe.confirmCardPayment(clientSecret);
  const confirmStatus =
    confirmCardPaymentResp &&
    confirmCardPaymentResp.paymentIntent &&
    confirmCardPaymentResp.paymentIntent.status;

  if (confirmStatus === 'requires_action') {
    return confirmCardPaymentRecursively(stripe, clientSecret);
  }

  if (confirmStatus === 'processing') {
    return waitForPaymentProcessing(stripe, clientSecret);
  }

  if (confirmStatus === 'succeeded') {
    return true;
  }

  return false;
};

export const sortUserMarkets = (
  markets,
  sortKey: string,
  sortType: 'alpha-a-z' | 'alpha-z-a' | 'date-a-z' | 'date-z-a'
) => {
  if (!markets || markets.length === 0) return markets;

  markets = markets.filter(markets => markets[sortKey]);

  const sortTypesDateWise = ['date-a-z', 'date-z-a'];

  const sortAlphaWise = () => {
    markets = markets.sort((a: string, b: string) => a[sortKey].localeCompare(b[sortKey]));
    return sortType === 'alpha-z-a' ? markets.reverse() : markets;
  };

  const sortDateWise = () => {
    markets = markets.sort(
      (a: string, b: string) => new Date(a[sortKey]).getTime() - new Date(b[sortKey]).getTime()
    );
    return sortType === 'date-z-a' ? markets : markets.reverse();
  };

  return sortTypesDateWise.includes(sortType) ? sortDateWise() : sortAlphaWise();
};

export const isDemoMarket = () => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const loginCountryCode = timeZoneCCMap[userTimeZone] || 'US';
  const dummyMarket =
    DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE[loginCountryCode]?.overview ||
    DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE['US']?.overview;
  const currentPath = window.location.pathname.toLowerCase();
  const dummyMarketURL = getDummyMarketURL(dummyMarket);

  return currentPath.includes(dummyMarketURL);
};

export const checkifDemoMarketWithMarketId = (marketId: string) => {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const loginCountryCode = timeZoneCCMap[userTimeZone] || 'US';
  const dummyMarket =
    DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE[loginCountryCode]?.overview ||
    DUMMY_MARKET_AS_PER_SIGNUP_COUNTRY_CODE['US']?.overview;
  return dummyMarket.id == marketId;
};

export const isMoreThanNDaysAgo = (dateString: string, N: number) => {
  const inputDate = moment(dateString, 'YYYY-MM-DD');
  const currentDate = moment().startOf('day');

  const targetDate = currentDate.subtract(N, 'days');

  return inputDate.isBefore(targetDate, 'day');
};

export const handleSaveDeleteAdvancedMarket = async (
  id,
  name,
  city,
  countryCode,
  country,
  userSubscriptionPlan,
  operation: 'save' | 'delete' = 'save'
) => {
  if (userSubscriptionPlan != 'scale' && operation === 'save') {
    return;
  }
  try {
    console.log('Operation: ', operation);
    const URL = 'https://iknejeg0yj.execute-api.us-east-2.amazonaws.com/default/saveAdvancedMarket';

    const res = await callApi(
      URL,
      {
        queryParams: Object.fromEntries(
          Object.entries({ id, name, city, countryCode, country }).filter(
            ([_, val]) => val !== undefined
          )
        ),
      },
      true,
      false,
      '',
      operation === 'delete' ? 'DELETE' : 'GET',
      true
    );
    if (res.message == 'success') {
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.log(`Error while performing ${operation} :`, err);
    return false;
  }
};

export const getSubscriptionPlanToUpgrade = (currentPlan: string) => {
  const planOrder: string[] = ['starter', 'expert', 'scale'];
  if (!planOrder.includes(currentPlan)) return 'expert';

  if (currentPlan === 'scale') {
    return 'scale';
  }
  const nextPlanToUpgrade = planOrder[planOrder.indexOf(currentPlan) + 1];

  return nextPlanToUpgrade as SubscriptionPlan;
};

export const getMlaMonthName = (monthName: string) => {
  try {
    const monthIndex: number = shortMonthNames
      .map(month => month.toLowerCase())
      .indexOf(monthName.toLowerCase());
    if (monthIndex === -1) {
      return monthName;
    }
    return mlaMonthsShort[monthIndex];
  } catch (err) {
    return monthName;
  }
};

// This function handles the tooltip click detection.
// As the tooltip is rendered from outside of the root, the clickaway don't detect the click by default
export const handleOutsideTooltipClick = (
  event: MouseEvent | TouchEvent,
  tooltipOpen: boolean,
  action: (open: boolean) => void
) => {
  const target = event.target as HTMLElement;
  const isTooltip = target.closest && target.closest('.MuiTooltip-tooltip');

  if (tooltipOpen && !isTooltip) {
    action(false);
  }
};

export const processIndividualListingData = listingData => {
  const revPAN = listingData['active_days_count_ltm']
    ? Math.round(listingData['annual_revenue_ltm'] / listingData['active_days_count_ltm'])
    : 0;
  const revenueFromCleaningFeeLTM = listingData['cleaning_fee']
    ? Math.round(listingData['cleaning_fee'] * listingData['no_of_bookings_ltm'])
    : 0;

  return {
    accommodates: listingData['accommodates'],
    activeDaysCount: listingData['active_days_count_ltm'],
    adrLTM: listingData['avg_booked_daily_rate_ltm'],
    amenities: listingData['amenities'],
    annualRevenueLTM: listingData['annual_revenue_ltm'] ? listingData['annual_revenue_ltm'] : 'N/A',
    bathrooms: listingData['bathrooms'],
    bedrooms: listingData['bedrooms'],
    cancellation_policy: listingData['cancellation_policy'],
    cleaningFee: listingData['cleaning_fee'],
    extraGuestFee: listingData['extra_fee_person_estimate'],
    hasLicense: listingData['license'] === 't' ? true : false,
    hostId: listingData['host_id'],
    hostListingCount: listingData['hostListingCount'],
    host_name: listingData['host_name'],
    last_seen: listingData['last_seen'],
    latitude: listingData['latitude'],
    listingID: listingData['listingID'],
    longitude: listingData['longitude'],
    minimum_nights: listingData['minimum_nights'],
    name: listingData['name'],
    numberOfBookingsLTM: listingData['no_of_bookings_ltm'],
    occupancyRateLTM: listingData['avg_occupancy_rate_ltm'] === 'locked'? 'locked' : Math.min(listingData['avg_occupancy_rate_ltm'], 95),
    property_type: listingData['room_and_property_type'],
    revPAN: revPAN,
    revenueFromCleaningFeeLTM: revenueFromCleaningFeeLTM,
    revenuePotential: listingData['revenue_potential'],
    review_scores_rating: round(listingData['reveiw_scores_rating'] / 20),
    room_type: listingData['room_and_property_type'],
    thumbnail_url: listingData['thumbnail_url'],
    visible_review_count: listingData['visible_review_count'],
    rest_thumbnails: listingData['thumbnail_url_extended'],
    markerType: 'full',
    visible: true,
    bookings: [],
    historicalMonthlyPerformance: {} as any,
    added_on: '',
    bookingComURL: listingData['booking_com_url'] || null,
    vrboURL: listingData['vrbo_url'] || null,
    premiumFactor: listingData['premium_factor'] ?? null,
  } as Listing;
};

export function formatDate(dateStr: string): string {
  const dateObj = new Date(dateStr);

  if (isNaN(dateObj.getTime())) {
    throw new Error('Invalid date format');
  }

  // Get day and determine suffix
  const day: number = dateObj.getDate();
  const suffix: string =
    day >= 11 && day <= 13
      ? 'th'
      : day % 10 === 1
      ? 'st'
      : day % 10 === 2
      ? 'nd'
      : day % 10 === 3
      ? 'rd'
      : 'th';

  // Get full month name
  const options: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' };
  const formattedMonthYear: string = dateObj
    .toLocaleDateString('en-US', options)
    .split(' ')
    .join(',');

  return `${day}${suffix} ${formattedMonthYear}`;
}

export const getUserPreferredCurrency = (defaultCurrency: string) => {
  const userSavedCurrency = localStorage.getItem('user-preferred-currency');

  if (userSavedCurrency && exchangeRates[userSavedCurrency]) {
    return userSavedCurrency;
  }

  return defaultCurrency;
};

export const checkIfSettingPage = () => {
  return window.location.pathname.includes('/user/settings');
};

export const setCookie = (name: string, value: string): void => {
  try {
    const hostname = window.location.hostname;
    const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
    const isProduction = hostname.endsWith('airbtics.com'); // Covers airbtics.com & app.airbtics.com

    // Expiration time = 10 years
    const maxAge = 60 * 60 * 24 * 365 * 10; // 10 years in seconds

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
      value
    )}; max-age=${maxAge}; path=/`;

    // Set domain for cross-subdomain access only in production
    if (isProduction) {
      cookieString += '; domain=.airbtics.com';
    }

    // Set SameSite policy based on environment
    if (isLocalhost) {
      cookieString += '; SameSite=Lax'; // Avoid restrictions on localhost
    } else {
      cookieString += '; SameSite=None'; // Required for cross-domain access
    }

    // Secure flag only for production (HTTPS required)
    if (!isLocalhost) {
      cookieString += '; Secure';
    }

    // Set the cookie
    document.cookie = cookieString;
  } catch (err) {
    console.error('Error while setting up cookie: ', err);
  }
};

export const closeKeyboard = () => {
  try {
    const activeElement = document.activeElement as HTMLElement | null;

    if (activeElement?.tagName === 'INPUT') {
      (activeElement as HTMLInputElement).blur();
    }
  } catch (err) {
    console.log('Error from closing the keyboard: ', err);
  }
};

export const formatUrl = (url: string) => {
  if (!url) return '';
  return url.startsWith('http') ? url : `https://${url}`;
};


export const getUserRemainingTopHostUnlockCredits = (user: User): number => {
  const userRemainingTopHostUnlockCredits = user.user_subscribed_market_wise_top_host_monthly;
  if (!userRemainingTopHostUnlockCredits) return 0;

  const creditUsedThisMonth = getCreditUsedThisMonth(userRemainingTopHostUnlockCredits);
  const usageLimit = MONTHLY_TOP_HOST_LIMIT[user.subscriptionPlan];
  if (!usageLimit) {
    return 0;
  }

  const remainingCredits = usageLimit - creditUsedThisMonth;
  return remainingCredits;
};

export const getCoordinatesFromWKT = (wktBoundaryString: string) => {
  if (wktBoundaryString.toUpperCase().startsWith('MULTIPOLYGON')) {
    return processMultiPolygon(wktBoundaryString);
  } else {
    return processPolygon(wktBoundaryString, '');
  }
};

export const generateWKTPolygon = (coordinates: number[][]) => {
  return `POLYGON ((${coordinates.map(coord => `${coord[0]} ${coord[1]}`).join(',')}))`;
};

export const calculatePercentiles = (data, quantiles = [0.25, 0.5, 0.75, 0.9]) => {
  if (data.length > 0) {
    data = data.filter(d => d !== null);
    return quantiles.map(q => d3.quantile(data.sort(d3.ascending), q));
  } else {
    // Return an array of zeros if the input array is empty
    return Array(quantiles.length).fill(0);
  }
};

export const removeAccent = (str: string): string => {
  if (!str) return '';
  return str
    .normalize('NFD') // decompose combined letters
    .replace(/[\u0300-\u036f]/g, ''); // remove diacritical marks
};

export const setUserDataToMailChimp = (fields: Array<[string, string | boolean]>) => {
  try {
    const URL =
      'https://fn7crazpf6.execute-api.us-east-2.amazonaws.com/default/handleMailChimpOpertations';
    return callApi(URL, { body: fields }, true, false, '', 'POST', true);
  } catch (err) {
    console.log('Error while setting user data to MailChimp: ', err);
    return (err as any)?.message;
  }
};


export const getCountryFromReportData = (
  reportData: any,
  checkBestMarketBlogURLOnly: boolean = false
): string => {
  const address = reportData?.primary_input?.address_full;
  if (!address || typeof address !== 'string') return '';

  const parts = address.split(',').map(part => part.trim());
  const rawCountry = parts[parts.length - 1];
  const key = normalizeCountryKey(rawCountry);

  const primaryLookup = buildCountryLookupMaps(BEST_AIRBNB_MARKET_COUNTRY_CODE_MAP);
  const secondaryLookup = checkBestMarketBlogURLOnly
    ? buildCountryLookupMaps(BEST_AIRBNB_MARKET_COUNTRY_CODE_MAP)
    : buildCountryLookupMaps(ALL_COUNTRY);

  const match =
    primaryLookup.lookupByName[key] ||
    primaryLookup.lookupByCode[key] ||
    secondaryLookup.lookupByName[key] ||
    secondaryLookup.lookupByCode[key];

  if (match) return match.name;

  const alias = COUNTRY_ALIASES[key];
  if (!alias) return '';

  const aliasKey = normalizeCountryKey(alias);

  return (
    primaryLookup.lookupByName[aliasKey]?.name || secondaryLookup.lookupByName[aliasKey]?.name || ''
  );
};

export const getBestMarketBlogURLByCountry = (country: string) => {
  const countrySlug = country.toLowerCase().replace(/ /g, '-');
  if (!countrySlug) return '';
  const prefix = BEST_MARKET_BLOGS_WITH_THE_PREFIX.includes(countrySlug) ? 'the-' : '';
  return `https://airbtics.com/best-airbnb-markets-${prefix}${countrySlug}`;
};

export const handleRedirectAfterSignup = (
  userDescription: string,
  userSubDescription: string,
  history: any,
  defaultRedirectUrl: string
) => {
  // Check for special no-redirection cases
  const isCalculatorPage = /\/airbnb-calculator(\/.*)?$/.test(defaultRedirectUrl || '');
  const isDemoMarketPage = defaultRedirectUrl?.includes('/airbnb-data/') && isDemoMarket();
  const shouldSkipRedirect =
    isCalculatorPage || (userSubDescription === 'neighborhood_research' && !isDemoMarketPage);

  // Special handling for new property investors
  if (userDescription === 'new_property_investor') {
    switch (userSubDescription) {
      case 'market_research':
        if (!shouldSkipRedirect) {
          history.push('/markets/compare');
        }
        break;

      case 'neighborhood_research':
        // Store a flag to show neighborhood research tutorial
        localStorage.setItem('show_neighborhood_tutorial', 'true');
        if (!shouldSkipRedirect) {
          history.push('/airbnb-data/landing');
        }
        break;

      case 'revenue_estimation':
        if (!shouldSkipRedirect) {
          history.push('/airbnb-calculator');
        }
        break;

      default:
        if (!shouldSkipRedirect) {
          history.push(defaultRedirectUrl || MARKET_HOME_CHAT_PATH);
        }
    }
  } else {
    // For all other cases, use the existing redirection logic
    if (!shouldSkipRedirect) {
      history.push(
        userDescription === 'property_manager'
          ? RoutesMap.Pricing
          : defaultRedirectUrl || MARKET_HOME_CHAT_PATH
      );
    }
  }

  if (shouldSkipRedirect) {
    window.location.pathname = defaultRedirectUrl || '/airbnb-data';
  }
};
export const getYearlyUpgradeFinalDueAmount = async (
  userSubscriptionPlan,
  userSubscriptionCurrency,
  setFinalDueAmount,
  options?: { isTestMode?: boolean; stripeAccount?: keyof typeof stripeConfig }
) => {
  setFinalDueAmount(null);

  const UPGRADE_SUBSCRIPTION_URL_TEST =
    'https://9s2r54r64l.execute-api.us-east-2.amazonaws.com/default/upgradeStripeSubscription';
  const UPGRADE_SUBSCRIPTION_URL =
    'https://9s2r54r64l.execute-api.us-east-2.amazonaws.com/default/upgradeStripeSubscription';

  try {
    const isTestMode = options?.isTestMode === true;
    const stripeAccount = options?.stripeAccount;
    const duration = 'yearly';

    // Prefer stripeConfig when account is provided, otherwise fall back to legacy ProductIDOptions
    const productIDFromStripeConfig =
      stripeAccount &&
      (isTestMode
        ? stripeConfig?.[stripeAccount]?.testProductIDOptions?.[userSubscriptionPlan]?.productID?.[
            duration
          ]
        : stripeConfig?.[stripeAccount]?.productIDOptions?.[userSubscriptionPlan]?.productID?.[
            duration
          ]);

    const fallbackProductID = ProductIDOptions[userSubscriptionPlan]?.productID?.[duration];
    const productID = productIDFromStripeConfig || fallbackProductID;

    const url = isTestMode ? UPGRADE_SUBSCRIPTION_URL_TEST : UPGRADE_SUBSCRIPTION_URL;
    const config = {
      queryParams: {
        newProductID: productID,
        newProductName: userSubscriptionPlan,
        newDuration: duration,
        operation: 'fetch_yearly_discounted_price_from_cancellation',
        currency: userSubscriptionCurrency,
        cancellation_discount: true,
        ...(isTestMode ? { isTest: true } : {}),
      },
    } as const;

    const resp = await callApi(url, config, true);
    const dueAmount = resp.yearly_discounted_price_from_cancellation;
    if (dueAmount && !isNaN(Number(dueAmount))) {
      setFinalDueAmount(dueAmount);
    } else {
      setFinalDueAmount(null);
    }
  } catch (err) {
    setFinalDueAmount(null);
  }
};

export const parseFilterValToApiResponse = (filterVal: FilterVal) => {
  const filters: Record<string, any> = {};

  const isDefault = (key: keyof FilterVal, value: any): boolean => {
    const defaultVal = DEFAULT_FILTER_VALUES[key];
    return JSON.stringify(defaultVal) === JSON.stringify(value);
  };

  const addMultiSelect = (key: keyof FilterVal, field: string, value: any[]) => {
    if (
      Array.isArray(value) &&
      value.length > 0 &&
      !(value.length === 1 && value[0] === 'all') &&
      !isDefault(key, value)
    ) {
      filters[field] = value;
    }
  };

  const addFlexibleRange = (
    key: keyof FilterVal,
    field: string,
    value: number[] | [number, null] | [null, number],
    keyMap?: Record<number, number>
  ) => {
    if (!isDefault(key, value) && Array.isArray(value) && value.length === 2) {
      const [min, max] = value;
      filters[field] = {
        min: min === undefined || min === null ? 0 : keyMap && min in keyMap ? keyMap[min] : min,
        max: max === undefined ? null : max === DEFAULT_FILTER_VALUES[key][1] ? null : max,
      };
    }
  };

  const addSingleSelect = (
    key: keyof FilterVal,
    field: string,
    value: any,
    valueMap?: Record<string, string>
  ) => {
    if (!isDefault(key, value) && value && value !== 'all' && value !== 'both') {
      filters[field] = valueMap ? valueMap[value] : value;
    }
  };

  const addBooleanMap = (key: keyof FilterVal, field: string, valueObj: Amenities) => {
    if (isDefault(key, valueObj)) return;
    const filtered = Object.fromEntries(
      Object.entries(valueObj).filter(([_, val]) => val !== null)
    );
    if (Object.keys(filtered).length > 0) {
      filters[field] = filtered;
    }
  };

  const addRevenueBucketFilter = (key: keyof FilterVal, field: string, value: (number | 'all')[]) => {
    // Don't send rev_bucket when user selected "Any" (no revenue filter)
    if (!Array.isArray(value) || !value.length || value.includes('all')) {
      return;
    }
    const mapped = value.map(val => {
      // 4 tiers: 0=Low revenue (le25), 1=Below avg (le50), 2=Above avg (le75), 3=Top earning (le100)
      if (val === 0) return 'le25';
      if (val === 1) return 'le50';
      if (val === 2) return 'le75';
      if (val === 3) return 'le100';
      if (typeof val === 'number' && val <= 25) return 'le25';
      if (typeof val === 'number' && val <= 50) return 'le50';
      if (typeof val === 'number' && val <= 75) return 'le75';
      return 'le100';
    });
    filters[field] = Array.from(mapped);
  };

  // Multi-selects with special values
  addMultiSelect('bedrooms', 'bedrooms', filterVal.bedrooms);
  addMultiSelect('bathrooms', 'bathrooms', filterVal.bathrooms);
  addMultiSelect('roomType', 'property_type', filterVal.roomType);
  addMultiSelect('priceTierFilter', 'price_tier', filterVal.priceTierFilter);
  addRevenueBucketFilter('revenueFilter', 'rev_bucket', filterVal.revenueFilter);

  // Flexible ranges
  addFlexibleRange('accommodates', 'sleeps', filterVal.accommodates);
  addFlexibleRange('minimum_nights', 'minstay', filterVal.minimum_nights);
  addFlexibleRange('rating', 'rating', filterVal.rating, { 3.9: 0 });

  addSingleSelect('number_of_reviews', 'reviews', filterVal.number_of_reviews);
  addSingleSelect('hostType', 'prof_mgmt', filterVal.hostType, {
    independent: 'false',
    professional: 'true',
    both: 'both',
  });

  // Amenities (only true values)
  addBooleanMap('amenities', 'amenity', filterVal.amenities);

  return { filters };
};

export const filterExampleSavedMarkets = (marketDetails: any, isArray: boolean = false) => {
  if (!marketDetails) return [];

  const filtered = isArray
    ? marketDetails.filter(
        market => !market.is_example && !checkifDemoMarketWithMarketId(market.market_id)
      )
    : Object.keys(marketDetails).filter(
        marketID => !marketDetails[marketID].is_example && !checkifDemoMarketWithMarketId(marketID)
      );

  return filtered;
};

export const getGradeColor = (grade: string) => {
  // default is colorless
  if (!grade) return '#00000000';
  const gradeUpper = grade.toUpperCase();
  const baseGrade = gradeUpper[0] || '';
  
  // B/C = green
  if (baseGrade === 'B' || baseGrade === 'C') {
    return COLOR_SUCCESS;
  }
  // D/E/F = yellow
  else if (baseGrade === 'D' || baseGrade === 'E' || baseGrade === 'F') {
    return COLOR_WARNING;
  }
  // A = special gradient (handled in component)
  else if (baseGrade === 'A') {
    return COLOR_TERTIARY_1; 
  }
  else {
    return COLOR_ERROR;
  }
};

export const getGradeAGradient = () => ({
  background: `linear-gradient(135deg, #000000, ${COLOR_PRIMARY_2})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
});

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const syncLocalstorageMarketSearchHistory = (marketID: string) => {
  try {
    if (!marketID) return;

    const searchAttemptHistory = localStorage.getItem(MARKET_SEARCH_HISTORY) || '{}';
    const userSearchHistory = JSON.parse(searchAttemptHistory);
    Object.keys(userSearchHistory).length < FREE_MARKET_SEARCH_LIMIT &&
      localStorage.setItem(
        MARKET_SEARCH_HISTORY,
        JSON.stringify({ ...userSearchHistory, [marketID]: true })
      );
  } catch (err) {
    console.error('Error while syncing market search history: ', err);
  }
};

export const isMarketSearchAllowed = (
  user: User,
  marketID: string | number,
  dummyMarketID: string | number,
  saveMarketSearchHistory: boolean = false
) => {
  // Workflow:
  // It is for the free user search - market search and the tailored regions
  // 1. User have free 5 searches.
  // 2. After user is searching a market - when the market is loaded, will be consider as a full search
  // 3. demo markets are not considered as a search
  // 4. Re-vistiting the same market will not be considered as a new search

  const searchAttemptHistory = localStorage.getItem(MARKET_SEARCH_HISTORY) || '{}';
  const userSearchHistory = JSON.parse(searchAttemptHistory);
  const noOfUserSearch = Object.keys(userSearchHistory).length || 0;

  if (marketID == dummyMarketID) {
    return true;
  }

  if (userSearchHistory) {
    Object.keys(userSearchHistory).forEach(marketID => {
      if (marketID == dummyMarketID) {
        delete userSearchHistory[dummyMarketID];
      }
    });
  }

  if (
    user.subscriptionPlan == 'starter' &&
    noOfUserSearch >= FREE_MARKET_SEARCH_LIMIT &&
    !userSearchHistory[marketID]
  ) {
    return false;
  } else if (marketID && user.subscriptionPlan == 'starter' && saveMarketSearchHistory) {
    localStorage.setItem(
      MARKET_SEARCH_HISTORY,
      JSON.stringify({ ...userSearchHistory, [marketID]: true })
    );
  }

  // Checking from db is currently disabled
  // if (
  //   user.subscriptionPlan == 'starter' &&
  //   user.marketSearchCount > FREE_MARKET_SEARCH_LIMIT - 2
  //   // -1 to account for the fact that count start from 0 instead of 1
  //   // another -1 to because getUserInfo gets the updated serach count from n+1 search
  // ) {
  //   return false;
  // }

  return true;
};

export const parseWKTStringToCoordinates = (
  wkt: string,
  isMultiPolygon: boolean,
  removeNaN: boolean = false
): number[][][] | number[][][][] => {
  // Parse one ring string into coords
  const parseRing = (ringStr: string): number[][] => {
    const coords = ringStr
      .trim()
      .split(',')
      .map(pair =>
        pair
          .trim()
          .split(/\s+/) // handle variable whitespace
          .map(Number)
      );

    const filtered = removeNaN ? coords.filter(c => !isNaN(c[0]) && !isNaN(c[1])) : coords;

    // Skip invalid rings
    if (filtered.length < 3) return [];

    // Ensure closure
    if (
      filtered.length > 0 &&
      (filtered[0][0] !== filtered[filtered.length - 1][0] ||
        filtered[0][1] !== filtered[filtered.length - 1][1])
    ) {
      filtered.push([...filtered[0]]);
    }

    return filtered;
  };

  if (isMultiPolygon) {
    // Remove MULTIPOLYGON keyword and outer parens
    const multiStr = wkt.replace(/^MULTIPOLYGON\s*\(\(\(/i, '').replace(/\)\)\)$/i, '');

    // Split polygons by )), ((
    const polygonStrings = multiStr.split(/\)\),\s*\(\(/);

    const multiPolygon: number[][][][] = polygonStrings.map(polyStr => {
      const ringStrings = polyStr.split(/\),\s*\(/);
      return ringStrings.map(parseRing);
    });

    return multiPolygon;
  } else {
    // Remove POLYGON keyword and outer parens
    const polyStr = wkt.replace(/^POLYGON\s*\(\(/i, '').replace(/\)\)$/i, '');

    const ringStrings = polyStr.split(/\),\s*\(/);

    const polygon: number[][][] = ringStrings.map(parseRing);
    return polygon;
  }
};

export const rechartsToSVG = (rechartsRef: any) => {
  let svgEl = rechartsRef.current;
  if (!svgEl) return;
  svgEl = svgEl.querySelector('svg');
  if (!svgEl) return;

  // Ensure xmlns for standalone SVG
  svgEl.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

  // Font Same as pdf
  svgEl.setAttribute('style', 'font-family: "Noto Sans", "Noto Sans KR", Arial, sans-serif');

  const source = new XMLSerializer().serializeToString(svgEl);

  return source;
};

export const getGraphExportCreditRequired = (
  rowsLength: number,
  graphType: keyof typeof GRAPH_EXPORT_LIMIT_MULTIPLIER
) => {
  console.log('rowsLength: ', rowsLength);
  console.log('graphType: ', graphType);
  console.log(
    'GRAPH_EXPORT_LIMIT_MULTIPLIER[graphType]: ',
    GRAPH_EXPORT_LIMIT_MULTIPLIER[graphType]
  );
  return Math.round((rowsLength - 1) * GRAPH_EXPORT_LIMIT_MULTIPLIER[graphType]); // -1 to account for the header row
};

export const formatMonthString = (month: string) => {
  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const monthNumber = month.split('-')[1];
  const monthName = monthNames[Number(monthNumber) - 1];
  const year = month.split('-')[0];
  return `${monthName.slice(0, 3)} ${year}`;
};

export const formatDateString = (inputString: string): string => {
  // convert 2025-09-16 to Sep 16, 2025
  const date = new Date(inputString);
  const month = date.toLocaleString('default', { month: 'short' });
  const day = date.toLocaleString('default', { day: '2-digit' });
  const year = date.getFullYear();
  return `${month} ${day}, ${year}`;
};

export const getWeekdayFromDate = (inputString: string): string => {
  const date = new Date(inputString);
  const weekday = date.toLocaleString('default', { weekday: 'short' });
  return weekday;
};

export const calculateDynamicYAxisRange = (data: any, padding: number = 0): [number, number] => {
  const occupancyRates = data.map((item: any) => item.occupancyRate);

  // Calculate min and max
  const rawMin = Math.min(...occupancyRates);
  const rawMax = Math.max(...occupancyRates);

  // If values are tightly grouped, like 79, 75, 75, make range more visually useful/padded
  let min, max;
  if (rawMax - rawMin <= 10) {
    min = Math.floor(rawMin / 10) * 10;
    max = Math.ceil(rawMax / 10) * 10;
    // edge case: if all values are almost the same and min==max, we want at least a 10 range
    if (min === max) {
      max = min + 10;
    }
  } else {
    min = Math.floor((rawMin - padding) / 5) * 5;
    max = Math.ceil((rawMax + padding) / 5) * 5;
  }

  return [min, max];
};


export const formatMarketName = (market: Search) => {
  if (!market.name) return '';

  const result = market.displayName || market.name;

  return capitalizeText(result);
};

export const getStaticMapWithPolygonAndMarkets = (
  markets: any[] | undefined = undefined,
  height: number | undefined = undefined,
  width: number | undefined = undefined
) => {
  const API_URL = 'https://maps.googleapis.com/maps/api/staticmap';

  let size: string = `size=${width}x${height}`;

  const color = '0x' + COLOR_PRIMARY_2.slice(1);

  let markers: string = '';
  if (markets && markets.length > 0) {
    markets.forEach(market => {
      markers += `&markers=color:${color}|label:${market.rank}|${market.center.lat},${market.center.lng}`;
    });
  }

  // const finalUrl = `${API_URL}?${size}&zoom=auto&${markers}&key=${MAP_KEY}`;

  const finalUrl = `${API_URL}?&${size}&zoom=auto&${markers}&key=${GOOGLE_MAPS_API_KEY}`;

  return finalUrl;
};

/** Mapbox Static Images API — lng,lat order. Pin color matches estimator primary (#037A90). */
export const getMapboxStaticPropertyPreviewUrl = (
  lat: number,
  lng: number,
  accessToken: string,
  opts?: { zoom?: number; width?: number; height?: number; stylePath?: string }
): string => {
  const zoom = opts?.zoom ?? 14;
  const width = opts?.width ?? 800;
  const height = opts?.height ?? 560;
  const stylePath = opts?.stylePath ?? 'mapbox/streets-v12';
  const pinHex = '037A90';
  const overlay = `pin-s+${pinHex}(${lng},${lat})`;
  const center = `${lng},${lat},${zoom}`;
  const size = `${width}x${height}@2x`;
  const path = `https://api.mapbox.com/styles/v1/${stylePath}/static/${encodeURIComponent(overlay)}/${center}/${size}`;
  return `${path}?access_token=${encodeURIComponent(accessToken)}`;
};
